/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React Base Styles
import colors from "assets/theme/base/colors";

// Images
import water_polo from "assets/images/sports/water_polo.svg";
import handball from "assets/images/sports/handball.svg";
import rugby_union from "assets/images/sports/rugby_union.svg";
import rugby_league from "assets/images/sports/rugby_league.svg";
import snooker from "assets/images/sports/snooker.svg";
import lacrosse from "assets/images/sports/lacrosse.svg";
import tennis from "assets/images/sports/tennis.svg";
import table_tennis from "assets/images/sports/table_tennis.svg";
import soccer from "assets/images/sports/soccer.svg";
import basketball from "assets/images/sports/basketball.svg";
import volleyball from "assets/images/sports/volleyball.svg";
import badminton from "assets/images/sports/badminton.svg";
import ice_hockey from "assets/images/sports/ice_hockey.svg";
import hockey from "assets/images/sports/hockey.svg";
import field_hockey from "assets/images/sports/field_hockey.svg";
import futsal from "assets/images/sports/futsal.svg";
import netball from "assets/images/sports/netball.svg";
import bowls from "assets/images/sports/bowls.svg";
import floorball from "assets/images/sports/floorball.svg";
import formula1 from "assets/images/sports/formula1.svg";
import mma from "assets/images/sports/mma.svg";
import curling from "assets/images/sports/curling.svg";
import boxing from "assets/images/sports/boxing.svg";
import baseball from "assets/images/sports/baseball.svg";
import darts from "assets/images/sports/darts.svg";
import golf from "assets/images/sports/golf.svg";
import american_football from "assets/images/sports/american_football.svg";
import greyhounds from "assets/images/sports/greyhounds.svg";
import horse_racing from "assets/images/sports/horse_racing.svg";
import trotting from "assets/images/sports/trotting.svg";
import cycling from "assets/images/sports/cycling.svg";
import squash from "assets/images/sports/squash.svg";
import cricket from "assets/images/sports/cricket.svg";
import aussie_rules from "assets/images/sports/australian_rules.svg";
import main_bg from "assets/images/main-bg.jpg";
import archery from "assets/images/sports/archery.svg";
import pistol_shooting from "assets/images/sports/pistol_shooting.svg";
import politics from "assets/images/sports/politics.svg";
import esports from "assets/images/sports/esports.svg";
import gaelic from "assets/images/sports/gaelic.svg";
import gaelicfootball from "assets/images/sports/gaelicfootball.svg";
import sailing from "assets/images/sports/sailing.svg";
import alpineskiing from "assets/images/sports/alpineskiing.svg";
import crosscountryskiing from "assets/images/sports/cross-countryskiing.svg";
import freestyleskiing from "assets/images/sports/alpineskiing.svg";
import nordicski from "assets/images/sports/nordicski.svg";
import skijumping from "assets/images/sports/alpineskiing.svg";
import surfing from "assets/images/sports/surfing.svg";
import speedway from "assets/images/sports/speedway.svg";
import motorbike from "assets/images/sports/speedway.svg";
import motorsport from "assets/images/sports/motorsport.svg";
import biathlon from "assets/images/sports/alpineskiing.svg";
import wintersports from "assets/images/sports/wintersports.svg";
import weightlifting from "assets/images/sports/weightlifting.svg";
import wrestling from "assets/images/sports/wrestling.svg";
import skeleton from "assets/images/sports/skeleton.svg";
import bowling from "assets/images/sports/bowling.svg";
import figureskating from "assets/images/sports/figureskating.svg";
import speedskating from "assets/images/sports/figureskating.svg";
import snowboarding from "assets/images/sports/snowboarding.svg";
import shorttrackspeedskating from "assets/images/sports/figureskating.svg";
import poker from "assets/images/sports/poker.svg";
import canoeing from "assets/images/sports/canoeing.svg";
import diving from "assets/images/sports/diving.svg";
import gymnastics from "assets/images/sports/gymnastics.svg";
import softball from "assets/images/sports/softball.svg";
import skateboarding from "assets/images/sports/skateboarding.svg";
import petanque from "assets/images/sports/petanque.svg";
import financials from "assets/images/sports/financials.svg";
import showjumping from "assets/images/sports/showjumping.svg";
import swimming from "assets/images/sports/swimming.svg";
import padel from "assets/images/sports/padel.svg";
import entertainment from "assets/images/sports/entertainment.svg";
import bobsleigh from "assets/images/sports/bobsleigh.svg";
import luge from "assets/images/sports/luge.svg";
import nordiccombined from "assets/images/sports/nordiccombined.svg";
import sepaktakraw from "assets/images/sports/sepaktakraw.svg";
import pool from "assets/images/sports/pool.svg";
import pelota from "assets/images/sports/pelota.svg";

import nodata from "assets/images/nodata.png";

import fixture_header_1 from "assets/images/bgs/filivebanner1.png";
import fixture_header_2 from "assets/images/bgs/filivebanner2.png";
import fixture_header_3 from "assets/images/bgs/filivebanner3.png";
import fixture_header_4 from "assets/images/bgs/filivebanner4.png";
import fixture_header_5 from "assets/images/bgs/filivebanner5.png";
import fixture_header_6 from "assets/images/bgs/filivebanner6.png";
import fixture_header_7 from "assets/images/bgs/filivebanner7.png";
import fixture_header_8 from "assets/images/bgs/filivebanner8.png";
import fixture_header_9 from "assets/images/bgs/filivebanner9.png";
import fixture_header_10 from "assets/images/bgs/filivebanner10.png";
import fixture_header_11 from "assets/images/bgs/filivebanner11.png";
import fixture_header_12 from "assets/images/bgs/filivebanner12.png";
import fixture_header_13 from "assets/images/bgs/filivebanner13.png";
import fixture_header_14 from "assets/images/bgs/filivebanner14.png";
import fixture_header_15 from "assets/images/bgs/filivebanner15.png";
import fixture_header_16 from "assets/images/bgs/filivebanner16.png";
import fixture_header_17 from "assets/images/main-bg.jpg";
import fixture_header_18 from "assets/images/bgs/filivebanner18.png";
import fixture_header_19 from "assets/images/bgs/filivebanner19.png";
import fixture_header_20 from "assets/images/bgs/filivebanner20.png";
import fixture_header_21 from "assets/images/bgs/filivebanner21.png";
import fixture_header_22 from "assets/images/bgs/filivebanner22.png";
import fixture_header_23 from "assets/images/bgs/filivebanner23.png";
import fixture_header_24 from "assets/images/bgs/filivebanner24.png";
import fixture_header_25 from "assets/images/bgs/filivebanner25.png";
import fixture_header_26 from "assets/images/bgs/filivebanner26.png";
import fixture_header_27 from "assets/images/bgs/filivebanner27.png";
import fixture_header_28 from "assets/images/bgs/filivebanner28.png";
import fixture_header_29 from "assets/images/bgs/filivebanner29.png";
import fixture_header_30 from "assets/images/bgs/filivebanner30.png";
import fixture_header_31 from "assets/images/bgs/filivebanner31.png";
import fixture_header_32 from "assets/images/bgs/filivebanner32.png";
import fixture_header_33 from "assets/images/bgs/filivebanner33.png";
import fixture_header_34 from "assets/images/main-bg.jpg";
import fixture_header_35 from "assets/images/bgs/filivebanner35.png";
import fixture_header_36 from "assets/images/main-bg.jpg";
import fixture_header_37 from "assets/images/bgs/filivebanner37.png";
import fixture_header_38 from "assets/images/bgs/filivebanner38.png";

import fixture_header_41 from "assets/images/bgs/filivebanner41.png";

import fixture_header_44 from "assets/images/bgs/filivebanner44.png";
import fixture_header_45 from "assets/images/bgs/filivebanner45.png";

import fixture_header_47 from "assets/images/bgs/filivebanner47.png";

import fixture_header_50 from "assets/images/bgs/filivebanner50.png";
import fixture_header_53 from "assets/images/bgs/filivebanner53.png";
import fixture_header_54 from "assets/images/bgs/filivebanner54.png";
import fixture_header_55 from "assets/images/bgs/filivebanner55.png";
import fixture_header_56 from "assets/images/bgs/filivebanner56.png";
import fixture_header_57 from "assets/images/bgs/filivebanner57.png";
import fixture_header_58 from "assets/images/bgs/filivebanner58.png";
import fixture_header_59 from "assets/images/bgs/filivebanner59.png";
import fixture_header_60 from "assets/images/bgs/filivebanner60.png";
import fixture_header_63 from "assets/images/bgs/filivebanner63.png";

const { info, dark } = colors;

const customColors = {
  vbet: "#d80e84 !important",
  stoiximan: "#06c !important",
  "1xbet": "#002f5f !important",
  betanode: "#ef3d00 !important",
  williamhill: "#105c86 !important",
  bet365: "#118d65 !important",
  mozzartbet: "#280174 !important",
  betradar: "#1cbee9 !important",
  draftkings: "#b0da87 !important",
  bwin: "#000000 !important",
  paddypower: "#0e4c40 !important",
  sbobet: "#001e60 !important",
  "188bet": "#f08b00 !important",
  sportingbet: "#6bbff6 !important",
  unibet: "#147b44 !important",
  feedthebet: "rgb(203, 12, 159) !important",
  fuse: "rgb(203, 12, 159) !important",
};

const globals = {
  customColors: {
    vbet: "#d80e84 !important",
    stoiximan: "#06c !important",
    "1xbet": "#14a0ff !important",
    betanode: "#ef3d00 !important",
    williamhill: "#2399e6 !important",
    bet365: "#118d65 !important",
    mozzartbet: "#ffc222 !important",
    betradar: "#1cbee9 !important",
    draftkings: "#b0da87 !important",
    bwin: "#ffd700 !important",
    paddypower: "#0e4c40 !important",
    sbobet: "#001e60 !important",
    "188bet": "#f08b00 !important",
    sportingbet: "#6bbff6 !important",
    unibet: "#147b44 !important",
    feedthebet: "rgb(203, 12, 159) !important",
    fuse: "rgb(203, 12, 159) !important",
  },
  html: {
    scrollBehavior: "smooth",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
  ".hide": {
    display: "none !important",
  },

  // "div:has(.cur-stlmnt-actions)": {
  //   width: "100% !important",
  // },

  ".table-checkbox": {
    width: "40px !important",
    maxWidth: "40px !important",
  },

  ".MuiPaper-elevation": {
    msOverflowStyle: "none !important",
    scrollbarWidth: "none !important",
  },
  ".providers-radio": {
    minWidth: "100px",
    marginLeft: "5px !important",
  },
  ".sports-checkbox": {
    minWidth: "180px",
    marginLeft: "5px !important",
  },

  ".sports-checkbox-master": {
    minWidth: "180px",
    marginLeft: "5px !important",
    color: "#cb0c9f !important",
  },

  ".sports-checkbox-master .MuiFormControlLabel-label": {
    fontFamily: '"Roboto","Helvetica","Arial",sans-serif !important',
    fontSize: "1rem !important",
    fontWeight: "400 !important",
    color: "#cb0c9f !important",
  },

  ".sports-checkbox .MuiFormControlLabel-label": {
    fontFamily: '"Roboto","Helvetica","Arial",sans-serif !important',
    fontSize: "1rem !important",
    fontWeight: "400 !important",
  },

  ".platform-sports-checkbox": {
    minWidth: "0px",
    marginLeft: "4px !important",
    marginRight: "4px !important",
  },

  ".platform-sports-checkbox .MuiFormControlLabel-label": {
    fontFamily: '"Roboto","Helvetica","Arial",sans-serif !important',
    fontSize: "1rem !important",
    fontWeight: "400 !important",
  },

  ".platform-sports-checkbox .p": {
    minWidth: "140px",
  },

  ".platform-checkbox-label": {
    fontSize: "1rem !important",
    minWidth: "140px",
    marginRight: "5px !important",
  },

  ".platform-sports-checkbox-label": {
    fontSize: "1rem !important",
    minWidth: "140px",
    marginRight: "5px !important",
  },

  ".platform-providers-item-holder": {
    maxWidth: "100px",
  },

  ".providers-checkbox": {
    minWidth: "20px",
    marginLeft: "5px !important",
    marginRight: "0px !important",
  },
  ".providers-checkbox .MuiFormControlLabel-label": {
    fontFamily: '"Roboto","Helvetica","Arial",sans-serif !important',
    fontSize: "1rem !important",
    fontWeight: "400 !important",
  },

  ".provider-checkbox-label": {
    fontSize: "1rem !important",
    // minWidth: "100px",
    marginRight: "5px !important",
  },

  ".provider-checkbox-label-master": {
    fontSize: "1rem !important",
    // minWidth: "100px",
    marginRight: "5px !important",
    color: "#cb0c9f !important",
  },

  "#demo-radio-buttons-group-label": {
    paddingTop: "20px",
  },

  "#esports-group-label": {
    paddingTop: "35px",
  },

  "#sports-selected-table": {
    scrollbarWidth: "thin",
  },
  "#create-template-input": {
    width: "100% !important",
  },
  ".Mui-disabled": {
    cursor: "not-allowed !important",
    opacity: "60% !important",
  },
  ".show-disable-pointer": {
    cursor: "not-allowed !important",
    opacity: "60% !important",
    pointerEvents: "all !important",
  },
  ".select-disabled": {
    cursor: "not-allowed !important",
    opacity: "60% !important",
    pointerEvents: "all !important",
  },
  ".select-disabled div": {
    cursor: "not-allowed !important",
    opacity: "60% !important",
    pointerEvents: "all !important",
  },
  ".select-disabled input": {
    cursor: "not-allowed !important",
    opacity: "60% !important",
    pointerEvents: "all !important",
  },
  ".select-disabled > div ": {
    cursor: "not-allowed !important",
    opacity: "60% !important",
    pointerEvents: "all !important",
  },
  ".select-disabled > div > div": {
    cursor: "not-allowed !important",
    opacity: "60% !important",
    pointerEvents: "all !important",
  },
  ".show-disable-pointer-blocked": {
    cursor: "not-allowed !important",
    opacity: "60% !important",
    pointerEvents: "all !important",
  },
  ".show-disable-pointer-blocked span": {
    cursor: "not-allowed !important",
    opacity: "60% !important",
    pointerEvents: "all !important",
  },
  ".blocked-item": {
    opacity: "0.5 !important",
  },
  "#close-wizard": {
    color: "#ff0083",
    fontSize: "1.2rem !important",
  },
  "#close-wizard-button": {
    height: 20,
    width: 20,
    borderRadius: "20px",
    padding: "20px 20px",
    minWidth: "30px",
    minHeight: "30px",
  },
  "table.MuiTable-root thead tr th div.MuiBox-root": {
    fontSize: "0.75rem !Important",
  },
  ".error": {
    fontSize: "0.55rem",
    color: "#ff0060 !important",
    opacity: "0.5",
  },
  ".letter-button.error": {
    color: "#ff0060 !important",
    opacity: "0.5",
  },
  "#newTemplateNameField": {
    border: "none",
    minWidth: "30vw",
  },
  "#newTemplateNameFieldHolder > div > div": {
    border: "none !important",
  },
  ".competition-open": {
    backgroundColor: "#e9e9e9",
    cursor: "pointer",
  },
  ".competition-closed": {},
  ".competition-closed:hover": {
    cursor: "pointer",
    backgroundColor: "#f7f7f7",
  },

  ".fixture-visible": {
    backgroundColor: "#f7f7f7",
  },
  ".fixture-hidden": {},
  ".accordion-selected": {
    backgroundColor: "#a70959 !important",
    color: "#fff !important",
  },
  ".accordion-selected > div > div > div > div.MuiAccordion-region": {
    backgroundColor: "#ffffffe0 !important",
  },
  ".accordion-open": {
    backgroundColor: "#cad7e3 !important",
  },
  ".accordion-open > div > div > div > div.MuiAccordion-region": {
    backgroundColor: "#f0f8ff !important",
  },
  ".accordion-closed": {
    backgroundColor: "aliceblue !important",
  },
  ".accordion-closed:hover": {
    backgroundColor: "#f1d8e4 !important",
  },
  ".leaf": {
    // paddingRight: "16px !important",
  },
  ".leaf-group": {
    marginLeft: "-10px !important",
    paddingLeft: "10px !important",
    width: "auto !important",
  },
  ".pregame": {
    borderLeft: "5px solid #045f82",
    backgroundColor: "#009fff1a",
  },
  ".inplay": {
    borderLeft: "5px solid #148204",
    backgroundColor: "#00ff1c1a",
  },
  ".leaf > div": {
    margin: "0px",
    paddingLeft: "10px !important",
  },
  ".leaf-group > div": {
    margin: "0px",
    paddingLeft: "0px",
  },
  ".leaf > div::before": {
    content: '""',
    listStyleType: "none",
    display: "none",
  },
  ".leaf.regular > div > .leaf-text > span": {
    paddingLeft: "5px !important",
    maxWidth: "100px",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  ".leaf-group > div::before": {
    content: '""',
    listStyleType: "none",
    display: "none",
  },
  ".leaf > a": {
    paddingLeft: "10px !important",
  },
  ".leaf-icon": {
    marginRight: "0px !important",
    paddingRight: "0px !important",
    minWidth: "24px !important",
  },

  ".ul-list": {
    paddingLeft: "10px !important",
    // backgroundColor: "#d7f2fa",
    width: "84%",
  },
  ".pregame-group a.active": {
    color: "#17c1e8 !important",
  },
  ".pregame-group a.active > li.leaf": {
    // backgroundColor: "#d6e8f25c !important",
    opacity: 1,
    background: "transparent",
    color: "#17c1e8",
    borderRadius: "none",
    background: "#ffffff",
    // display: "-webkit-box",
    // display: "-webkit-flex",
    // display: "-ms-flexbox",
    display: " flex",
    // -webkit-align-items: center,
    // -webkit-box-align: center,
    // -ms-flex-align: center,
    alignItems: "center",
    width: "100%",
    // padding: "0.675rem 0.8rem 0.675rem 1rem",
    // paddingRight: "0.8rem",
    // margin: "0 1rem",
    borderRadius: "0.5rem",
    cursor: "pointer",
    // -webkit-user-select: none,
    // -moz-user-select: none,
    // -ms-user-select: none,
    userSelect: "none",
    whiteSpace: "nowrap",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
  },
  ".pregame-group a.active > li.leaf > div": {
    color: "#17c1e8 !important",
  },
  ".pregame-group a.active > li.leaf > div > div": {
    color: "#17c1e8 !important",
  },
  ".pregame-group a.active > li.leaf > div > div > span": {
    color: "#17c1e8 !important",
  },
  ".inplay-group a.active": {
    color: "#17c1e8 !important",
  },
  ".inplay-group a.active > li.leaf": {
    // backgroundColor: "#d8f2d65c !important",
    opacity: 1,
    background: "transparent",
    color: "#17c1e8",
    borderRadius: "none",
    background: "#ffffff",
    // display: "-webkit-box",
    // display: "-webkit-flex",
    // display: "-ms-flexbox",
    display: " flex",
    // -webkit-align-items: center,
    // -webkit-box-align: center,
    // -ms-flex-align: center,
    alignItems: "center",
    width: "100%",
    // padding: "0.675rem 0.8rem 0.675rem 1rem",
    // paddingRight: "0.8rem",
    // margin: "0 1rem",
    borderRadius: "0.5rem",
    cursor: "pointer",
    // -webkit-user-select: none,
    // -moz-user-select: none,
    // -ms-user-select: none,
    userSelect: "none",
    whiteSpace: "nowrap",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
  },
  ".inplay-group a.active > li.leaf > div": {
    color: "#17c1e8 !important",
  },
  ".inplay-group a.active > li.leaf > div > div": {
    color: "#17c1e8 !important",
  },
  ".inplay-group a.active > li.leaf > div > div > span": {
    color: "#17c1e8 !important",
  },
  ".topAlert": {
    // position: "fixed",
    // top: "0px",
    opacity: ".7 !important",
    // minWidth: "80vw",
    zIndex: "1000",
    margin: "auto",
    // left: "10vw",
  },
  ".leaf-sub-text > span": {
    opacity: "0.4",
    fontSize: "0.65rem !important",
    boxShadow: "0px 0px 5px #9d9d9d",
    borderRadius: "20px",
    backgroundColor: "#cb0c9f",
    color: "#fff !important",
    width: "fit-content",
    float: "right",
    paddingLeft: "4px",
    paddingRight: "5px",
  },
  ".regular": {
    borderLeft: "5px solid transparent",
  },
  ".inplay-group a > li.leaf > div > .leaf-sub-text > span": {
    opacity: "0.4 !important",
    backgroundColor: "#525f7f",
  },
  ".pregame-group a > li.leaf > div > .leaf-sub-text > span": {
    opacity: "0.4  !important",
    backgroundColor: "#525f7f",
  },
  ".inplay-group a.active > li.leaf > div > .leaf-sub-text > span": {
    color: "#fff !important",
    opacity: "1 !important",
    backgroundColor: "#cb0c9f",
  },
  ".pregame-group a.active > li.leaf > div > .leaf-sub-text > span": {
    color: "#fff !important",
    opacity: "1 !important",
    backgroundColor: "#cb0c9f",
  },
  ".apply-template-btn": {
    fontSize: "x-large",
    color: "rgb(255, 255, 255)",
    maxWidth: "35px",
    maxHeight: "30px",
  },
  ".float-templatename-show-btn": {
    fontSize: "small !important",
    color: "rgb(255, 255, 255)",
    maxHeight: "35px",
  },
  ".float-templatename-show-btn > p": {
    fontSize: "small !important",
    color: "rgb(255, 255, 255)",
    paddingLeft: "5px",
  },
  ".login-bg": {
    background: `url(${main_bg}) !important`,
  },
  ".login-form": {
    borderRadius: "30px",
    backgroundColor: "#ffffffde !important",
    boxShadow: "0px 0px 50px #000",
  },
  ".navbar-menu-holder": {
    display: "flex",
  },
  ".platform-title": {
    fontSize: "small !important",
    color: "#ff00a7 !important",
    lineHeight: "26px !important",
  },
  ".refresh-switch-holder": {
    padding: "0px !important",
    paddingRight: "0px !important",
    margin: "0px",
    float: "right",
  },
  ".refresh-switch-label": {
    marginLeft: "5px",
    color: "#67748e",
    minWidth: "50px",
    display: "inline-block",
    textAlign: "left",
  },
  ".user-menu-button > .singout-label": {
    fontSize: "0.85rem !important",
    fontWeight: "normal",
  },
  ".user-menu-button > .singout-icon": {
    fontSize: "1.25rem !important",
  },
  ".grey-holder": {
    backgroundColor: "#cecece24 !important",
    padding: "10px",
  },

  ".provider-button": {
    pointerEvents: "all !important",
  },

  ".provider-button-slug": {
    pointerEvents: "all !important",
  },

  ".MuiButton-outlined.provider-button-slug:hover": {
    borderColor: "#d80e84 !important",
    backgroundColor: "#d80e8430 !important",
  },
  ".provider-button-slug:disabled": {
    borderColor: "#d80e84 !important",
    cursor: "not-allowed! important",
    pointerEvents: "all !important",
  },
  ".settlement-provider": {
    paddingTop: "0.16rem",
    paddingBottom: "0.16rem",
  },

  ".MuiButton-contained.provider-button-fuse": {
    borderColor: "#d80e84 !important",
    backgroundColor: "#d80e84 !important",
  },

  ".MuiButton-contained.provider-button-fuse:hover": {
    backgroundColor: "#d80e8430 !important",
  },

  ".MuiButton-outlined.provider-button-fuse:hover": {
    borderColor: "#d80e84 !important",
    backgroundColor: "#d80e8430 !important",
  },

  ".MuiButton-outlined.provider-button-fuse:disabled": {
    borderColor: "#d80e84 !important",
    backgroundColor: "#d80e8430 !important",
  },

  ".MuiButton-contained.provider-button-feedthebet": {
    borderColor: "#d80e84 !important",
    backgroundColor: "#d80e84 !important",
  },

  ".MuiButton-contained.provider-button-feedthebet:hover": {
    backgroundColor: "#d80e8430 !important",
  },

  ".MuiButton-outlined.provider-button-feedthebet:hover": {
    borderColor: "#d80e84 !important",
    backgroundColor: "#d80e8430 !important",
  },

  ".MuiButton-outlined.provider-button-feedthebet:disabled": {
    borderColor: "#d80e84 !important",
    backgroundColor: "#d80e8430 !important",
  },

  ".MuiButton-contained.provider-button-betanode": {
    borderColor: "#ef3d00 !important",
    backgroundColor: "#ef3d00 !important",
  },

  ".MuiButton-contained.provider-button-betanode:hover": {
    backgroundColor: "#ef3d0030 !important",
  },

  ".MuiButton-outlined.provider-button-betanode:hover": {
    borderColor: "#ef3d00 !important",
    backgroundColor: "#ef3d0030 !important",
  },

  ".MuiButton-outlined.provider-button-betanode:disabled": {
    borderColor: "#ef3d00 !important",
    backgroundColor: "#ef3d0030 !important",
  },

  ".MuiButton-contained.provider-button-stoiximan": {
    borderColor: "#06c !important",
    backgroundColor: "#06c !important",
  },

  ".MuiButton-contained.provider-button-stoiximan:hover": {
    backgroundColor: "#0066cc30 !important",
  },

  ".MuiButton-outlined.provider-button-stoiximan:hover": {
    borderColor: "#06c !important",
    backgroundColor: "#0066cc30 !important",
  },

  ".MuiButton-outlined.provider-button-stoiximan:disabled": {
    borderColor: "#06c !important",
    backgroundColor: "#0066cc30 !important",
  },

  ".MuiButton-contained.provider-button-vbet": {
    borderColor: "#d80e84 !important",
    backgroundColor: "#d80e84 !important",
  },

  ".MuiButton-contained.provider-button-vbet:hover": {
    backgroundColor: "#d80e8430 !important",
  },

  ".MuiButton-outlined.provider-button-vbet:hover": {
    borderColor: "#d80e84 !important",
    backgroundColor: "#d80e8430 !important",
  },

  ".MuiButton-outlined.provider-button-vbet:disabled": {
    borderColor: "#d80e84 !important",
    backgroundColor: "#d80e8430 !important",
  },

  ".MuiButton-contained.provider-button-bet365": {
    borderColor: "#118d65 !important",
    backgroundColor: "#118d65 !important",
  },

  ".MuiButton-contained.provider-button-bet365:hover": {
    backgroundColor: "#118d6530 !important",
  },

  ".MuiButton-outlined.provider-button-bet365:hover": {
    borderColor: "#118d65 !important",
    backgroundColor: "#118d6530 !important",
  },

  ".MuiButton-outlined.provider-button-bet365:disabled": {
    borderColor: "#118d65 !important",
    backgroundColor: "#118d6530 !important",
  },

  ".MuiButton-contained.provider-button-unibet": {
    borderColor: "#147b44 !important",
    backgroundColor: "#147b44 !important",
  },

  ".MuiButton-contained.provider-button-unibet:hover": {
    backgroundColor: "#147b4430 !important",
  },

  ".MuiButton-outlined.provider-button-unibet:hover": {
    borderColor: "#147b44 !important",
    backgroundColor: "#147b4430 !important",
  },

  ".MuiButton-outlined.provider-button-unibet:disabled": {
    borderColor: "#147b44 !important",
    backgroundColor: "#147b4430 !important",
  },

  ".MuiButton-contained.provider-button-williamhill": {
    borderColor: "#105c86 !important",
    backgroundColor: "#105c86 !important",
  },

  ".MuiButton-contained.provider-button-williamhill:hover": {
    backgroundColor: "#105c8630 !important",
  },

  ".MuiButton-outlined.provider-button-williamhill:hover": {
    borderColor: "#105c86 !important",
    backgroundColor: "#105c8630 !important",
  },

  ".MuiButton-outlined.provider-button-williamhill:disabled": {
    borderColor: "#105c86 !important",
    backgroundColor: "#105c8630 !important",
  },

  ".MuiButton-contained.provider-button-mozzartbet": {
    borderColor: "#280174 !important",
    backgroundColor: "#280174 !important",
  },

  ".MuiButton-contained.provider-button-mozzartbet:hover": {
    backgroundColor: "#28017430 !important",
  },

  ".MuiButton-outlined.provider-button-mozzartbet:hover": {
    borderColor: "#280174 !important",
    backgroundColor: "#28017430 !important",
  },

  ".MuiButton-outlined.provider-button-mozzartbet:disabled": {
    borderColor: "#280174 !important",
    backgroundColor: "#28017430 !important",
  },

  ".MuiButton-contained.provider-button-betradar": {
    borderColor: "#105c86 !important",
    backgroundColor: "#105c86 !important",
  },

  ".MuiButton-contained.provider-button-betradar:hover": {
    backgroundColor: "#105c8630 !important",
  },

  ".MuiButton-outlined.provider-button-betradar:hover": {
    borderColor: "#105c86 !important",
    backgroundColor: "#105c8630 !important",
  },

  ".MuiButton-outlined.provider-button-betradar:disabled": {
    borderColor: "#105c86 !important",
    backgroundColor: "#105c8630 !important",
  },

  ".MuiButton-contained.provider-button-sbobet": {
    borderColor: "#001e60 !important",
    backgroundColor: "#001e60 !important",
  },

  ".MuiButton-contained.provider-button-sbobet:hover": {
    backgroundColor: "#001e6030 !important",
  },

  ".MuiButton-outlined.provider-button-sbobet:hover": {
    borderColor: "#001e60 !important",
    backgroundColor: "#001e6030 !important",
  },

  ".MuiButton-outlined.provider-button-sbobet:disabled": {
    borderColor: "#001e60 !important",
    backgroundColor: "#001e6030 !important",
  },

  ".MuiButton-contained.provider-button-draftkings": {
    borderColor: "#b0da87 !important",
    backgroundColor: "#b0da87 !important",
  },

  ".MuiButton-contained.provider-button-draftkings:hover": {
    backgroundColor: "#b0da8730 !important",
  },

  ".MuiButton-outlined.provider-button-draftkings:hover": {
    borderColor: "#61b510 !important",
    backgroundColor: "#b0da8730 !important",
  },

  ".MuiButton-outlined.provider-button-draftkings:disabled": {
    borderColor: "#61b510 !important",
    backgroundColor: "#b0da8730 !important",
  },

  ".MuiButton-contained.provider-button-bwin": {
    borderColor: "#000000 !important",
    backgroundColor: "#000000 !important",
  },

  ".MuiButton-contained.provider-button-bwin:hover": {
    backgroundColor: "#00000030 !important",
  },

  ".MuiButton-outlined.provider-button-bwin:hover": {
    borderColor: "#000000; !important",
    backgroundColor: "#00000030 !important",
  },

  ".MuiButton-outlined.provider-button-bwin:disabled": {
    borderColor: "#000000; !important",
    backgroundColor: "#00000030 !important",
  },

  ".MuiButton-contained.provider-button-188bet": {
    borderColor: "#000000 !important",
    backgroundColor: "#000000 !important",
  },

  ".MuiButton-contained.provider-button-188bet:hover": {
    backgroundColor: "#00000030 !important",
  },

  ".MuiButton-outlined.provider-button-188bet:hover": {
    borderColor: "#000000; !important",
    backgroundColor: "#00000030 !important",
  },

  ".MuiButton-outlined.provider-button-188bet:disabled": {
    borderColor: "#000000; !important",
    backgroundColor: "#00000030 !important",
  },

  ".MuiButton-contained.provider-button-paddypower": {
    borderColor: "#0e4c40; !important",
    backgroundColor: "#0e4c40 !important",
  },

  ".MuiButton-contained.provider-button-paddypower:hover": {
    backgroundColor: "#0e4c4030 !important",
  },

  ".MuiButton-outlined.provider-button-paddypower:hover": {
    borderColor: "#0e4c40; !important",
    backgroundColor: "#0e4c4030 !important",
  },

  ".MuiButton-outlined.provider-button-paddypower:disabled": {
    borderColor: "#0e4c40; !important",
    backgroundColor: "#0e4c4030 !important",
  },

  ".MuiButton-contained.provider-button-1xbet": {
    borderColor: "#002f5f !important",
    backgroundColor: "#002f5f !important",
  },

  ".MuiButton-contained.provider-button-1xbet:hover": {
    backgroundColor: "#002f5f30 !important",
  },

  ".MuiButton-outlined.provider-button-1xbet:hover": {
    borderColor: "#002f5f !important",
    backgroundColor: "#002f5f30 !important",
  },

  ".MuiButton-outlined.provider-button-1xbet:disabled": {
    borderColor: "#002f5f !important",
    backgroundColor: "#002f5f30 !important",
  },

  ".MuiButton-contained.provider-button-sportingbet": {
    borderColor: "#6bbff6 !important",
    backgroundColor: "#6bbff6 !important",
  },

  ".MuiButton-contained.provider-button-sportingbet:hover": {
    backgroundColor: "#6bbff630 !important",
  },

  ".MuiButton-outlined.provider-button-sportingbet:hover": {
    borderColor: "#6bbff6 !important",
    backgroundColor: "#6bbff630 !important",
  },

  ".MuiButton-outlined.provider-button-sportingbet:disabled": {
    borderColor: "#6bbff6 !important",
    backgroundColor: "#6bbff630 !important",
  },

  ".user-info-card": {
    width: "100%",
  },

  ".wizard-select-all-holder": {
    textAlign: "right",
    borderBottom: "1px solid #000",
    marginBottom: "15px",
  },

  ".select-all-holder": {
    textAlign: "right",
    borderBottom: "1px solid #cecece",
    marginBottom: "15px",
  },

  ".platform-fields-holder": {
    paddingTop: "0px !important",
  },

  ".platform-config-main-body": {
    marginBottom: "20px",
  },

  ".validation-error": {
    margin: "0px",
    fontFamily: "Roboto",
    fontSize: "0.75rem",
    fontWeight: "400",
    lineHeight: "1.27",
    letterSpacing: "0.03333em",
    opacity: "1",
    textTransform: "none",
    verticalAlign: "unset",
    textDecoration: "none",
    color: "rgb(234, 6, 6)",
    display: "block",
    paddingTop: "10px",
  },

  ".wizard-info": {
    margin: 0,
    fontSize: "0.90rem",
    fontWeight: 400,
    lineHeight: 1.6,
    letterSpacing: "0.01071em",
    opacity: 1,
    textTransform: "none",
    verticalAlign: "unset",
    textDecoration: "none",
    color: "#67748e",
    fontWeight: "normal",
  },
  ".wizard-formfield-info": {
    margin: 0,
    fontSize: "0.90rem",
    fontWeight: 400,
    lineHeight: 1.6,
    letterSpacing: "0.01071em",
    opacity: 1,
    textTransform: "none",
    verticalAlign: "unset",
    textDecoration: "none",
    fontWeight: "normal",
  },
  ".info-icon": {
    color: "#17c1e8",
    fontSize: "10px !important",
    marginLeft: "5px",
  },
  ".info-icon-filters": {
    color: "#17c1e8",
    fontSize: "10px !important",
    marginLeft: "5px",
  },
  ".success-icon": {
    color: "#66d432 !important",
    fontSize: "10px !important",
    marginLeft: "5px",
    padding: "0px !important",
    margin: "0px !important",
    minWidth: "30px !important",
  },

  ".warning-icon": {
    color: "#f78812 !important",
    fontSize: "10px !important",
    marginLeft: "5px",
    padding: "0px !important",
    margin: "0px !important",
    minWidth: "30px !important",
  },

  ".error-icon": {
    color: "#f71212 !important",
    fontSize: "10px !important",
    marginLeft: "5px",
    padding: "0px !important",
    margin: "0px !important",
    minWidth: "30px !important",
  },

  ".info-icon-button": {
    color: "#17c1e8 !important",
    fontSize: "10px !important",
    marginLeft: "0px !important",
    padding: "0px !important",
    margin: "0px !important",
    minWidth: "20px !important",
  },

  ".success-icon-button": {
    color: "#66d432 !important",
    fontSize: "10px !important",
    marginLeft: "0px !important",
    padding: "0px !important",
    margin: "0px !important",
    minWidth: "20px !important",
  },

  ".warning-icon-button": {
    color: "#f78812 !important",
    fontSize: "10px !important",
    marginLeft: "0px !important",
    padding: "0px !important",
    margin: "0px !important",
    minWidth: "20px !important",
  },

  ".error-icon-button": {
    color: "#f71212 !important",
    fontSize: "10px !important",
    marginLeft: "0px !important",
    padding: "0px !important",
    margin: "0px !important",
    minWidth: "20px !important",
  },

  ".fake-settle-icon-button": {
    width: "1em !important",
    minWidth: "1em !important",
    maxWidth: "1em !important",
  },

  ".MuiButton-outlined-info": {
    borderColor: "#17c1e8 !important",
    backgroundColor: "#17c1e800 !important",
    color: "#17c1e8 !important",
    margin: "0px 2px 0px 2px !important",
    padding: "0px 10px 0px 10px !important",
  },

  ".MuiButton-outlined-info:hover": {
    borderColor: "#17c1e8 !important",
    backgroundColor: "#17c1e820 !important",
    margin: "0px 2px 0px 2px !important",
    padding: "0px 10px 0px 10px !important",
  },

  ".MuiButton-outlined-info:disabled": {
    borderColor: "#17c1e8 !important",
    backgroundColor: "#17c1e820 !important",
    margin: "0px 2px 0px 2px !important",
    padding: "0px 10px 0px 10px !important",
  },

  ".MuiButton-outlined-success": {
    borderColor: "#66d432 !important",
    backgroundColor: "#66d43200 !important",
    color: "#66d432 !important",
    margin: "0px 2px 0px 2px !important",
    padding: "0px 10px 0px 10px !important",
  },

  ".MuiButton-outlined-success:hover": {
    borderColor: "#66d432 !important",
    backgroundColor: "#66d43220 !important",
    margin: "0px 2px 0px 2px !important",
    padding: "0px 10px 0px 10px !important",
  },

  ".MuiButton-outlined-success:disabled": {
    borderColor: "#66d432 !important",
    backgroundColor: "#66d43220 !important",
    margin: "0px 2px 0px 2px !important",
    padding: "0px 10px 0px 10px !important",
  },

  ".MuiButton-outlined-error": {
    borderColor: "#f71212 !important",
    backgroundColor: "#f7121200 !important",
    color: "#f71212 !important",
    margin: "0px 2px 0px 2px !important",
    padding: "0px 10px 0px 10px !important",
  },

  ".MuiButton-outlined-error:hover": {
    borderColor: "#f71212 !important",
    backgroundColor: "#f7121220 !important",
    margin: "0px 2px 0px 2px !important",
    padding: "0px 10px 0px 10px !important",
  },

  ".MuiButton-outlined-error:disabled": {
    borderColor: "#f71212 !important",
    backgroundColor: "#f7121220 !important",
    margin: "0px 2px 0px 2px !important",
    padding: "0px 10px 0px 10px !important",
  },

  ".MuiButton-outlined-warning": {
    borderColor: "#f78812 !important",
    backgroundColor: "#f7881200 !important",
    color: "#f78812 !important",
    margin: "0px 2px 0px 2px !important",
    padding: "0px 10px 0px 10px !important",
  },

  ".MuiButton-outlined-warning:hover": {
    borderColor: "#f78812 !important",
    backgroundColor: "#f7881220 !important",
    margin: "0px 2px 0px 2px !important",
    padding: "0px 10px 0px 10px !important",
  },

  ".MuiButton-outlined-warning:disabled": {
    borderColor: "#f78812 !important",
    backgroundColor: "#f7881220 !important",
    margin: "0px 2px 0px 2px !important",
    padding: "0px 10px 0px 10px !important",
  },

  ".flexy": {
    display: "flex !important",
  },

  ".collapse-sidenav": {
    color: "#17c1e8",
    fontSize: "10px !important",
    marginLeft: "5px",
  },

  ".settlement-outcomes": {
    width: "120px !important",
  },

  ".bet-odd-settlement-outcomes": {
    width: "120px !important",
    backgroundColor: "#fff",
    borderRadius: "10px",
  },

  ".settlement-outcomes > div:nth-of-type(2)": {
    position: "relative",
    zIndex: 10000,
  },

  ".bet-odd-settlement-outcomes > div:nth-of-type(2)": {
    position: "relative",
    zIndex: 10000,
  },

  ".material-icons-round.info-icon-filters": {
    fontSize: "14px !important",
    cursor: "help",
  },

  ".material-icons-round.collapse-sidenav": {
    fontSize: "14px !important",
    cursor: "pointer",
  },

  ".wizard-validation-error": {
    margin: "0px",
    fontFamily: "Roboto",
    fontSize: "0.75rem",
    fontWeight: "400",
    lineHeight: "1.27",
    letterSpacing: "0.03333em",
    opacity: "1",
    textTransform: "none",
    verticalAlign: "unset",
    textDecoration: "none",
    color: "rgb(234, 6, 6)",
    display: "block",
    paddingTop: "10px",
  },
  ".leaf-group.regular > div > .leaf-text > span": {
    paddingLeft: "5px !important",
  },
  ".regular-group a.active": {
    color: "#344767 !important",
  },
  ".regular-group a.active > li.leaf": {
    color: "#344767 !important",
  },
  ".regular-group a.active > li.leaf > div": {
    color: "#344767 !important",
  },
  ".regular-group a.active > li.leaf > div > div": {
    color: "#344767 !important",
  },
  ".regular-group a.active > li.leaf > div > div.bubble": {
    color: "#ffffff !important",
  },
  ".regular-group a.active > li.leaf > div > div > span": {
    color: "#344767 !important",
  },
  ".regular-group > li": {
    paddingLeft: "20px !important",
  },
  ".MuiDialog-paper": {
    overflow: "visible !important",
  },
  ".disabled-form-item": {
    opacity: "0.3 !important",
    cursor: "not-allowed",
  },
  ".success": {
    color: "green",
  },
  ".error": {
    color: "red",
  },
  ".centered": {
    textAlign: "center",
  },
  ".editable-cell": {
    border: "none !important",
    // maxWidth: "100% !important",
  },

  ".editable-cell-percentage": {
    border: "none !important",
    maxWidth: "30% !important",
  },

  ".editable-cell-percentage > input": {
    textAlign: "right !important;",
    cursor: "text",
    maxWidth: "100% !important",
  },

  ".editable-cell-percentage > input:hover": {
    borderBottom: "1px solid rgba(129, 227, 249, 0.6) !important",
    textAlign: "right !important;",
    cursor: "text",
    // maxWidth: "100% !important",
  },

  ".sport-editable > tr > td": {
    paddingRight: "0px",
    paddingLeft: "10px",
    minWidth: "max-content",
  },
  ".sport-editable > tr > td > div": {
    width: "100% !important",
  },
  ".sport-editable > tr > td:first-of-type": {
    paddingRight: "24px",
    paddingLeft: "24px !important",
    // maxWidth: "200px !important",
    minWidth: "max-content",
    width: "max-content",
  },
  ".sport-editable > tr > td:first-of-type > div": {
    // width: "auto !important",
    width: "max-content !important",
  },
  ".sport-editable > tr > td:last-of-type": {
    paddingRight: "24px",
    paddingLeft: "10px !important",
  },
  ".sport-editable > tr > th": {
    paddingRight: "0px",
    paddingLeft: "10px",
  },
  ".sport-editable > tr > th:first-of-type": {
    paddingRight: "24px",
    paddingLeft: "24px !important",
    minWidth: "300px",
  },
  ".sport-editable > tr > th:last-of-type": {
    paddingRight: "24px",
    paddingLeft: "10px !important",
  },

  ".region-editable > tr > td": {
    paddingRight: "0px",
    paddingLeft: "10px",
    minWidth: "max-content",
  },
  ".region-editable > tr > td > div": {
    width: "100% !important",
  },
  ".region-editable > tr > td:first-of-type": {
    paddingRight: "24px",
    paddingLeft: "24px !important",
    // maxWidth: "200px !important",
    minWidth: "max-content",
    width: "max-content",
  },
  ".region-editable > tr > td:first-of-type > div": {
    // width: "auto !important",
    width: "max-content !important",
  },
  ".region-editable > tr > td:last-of-type": {
    paddingRight: "24px",
    paddingLeft: "10px !important",
  },
  ".region-editable > tr > th": {
    paddingRight: "0px",
    paddingLeft: "10px",
  },
  ".region-editable > tr > th:first-of-type": {
    paddingRight: "24px",
    paddingLeft: "24px !important",
    minWidth: "300px",
  },
  ".region-editable > tr > th:last-of-type": {
    paddingRight: "24px",
    paddingLeft: "10px !important",
  },

  ".comp-editable > tr > td": {
    paddingRight: "0px",
    paddingLeft: "10px",
    // width: "auto !important",
  },
  ".comp-editable > tr > td > div:has(.translations-cell)": {
    width: "100% !important",
  },
  ".comp-editable > tr > td:first-of-type": {
    paddingRight: "24px",
    paddingLeft: "24px !important",
    // maxWidth: "200px !important",
    width: "min-content",
  },
  ".comp-editable > tr > td:first-of-type > div": {
    // width: "auto !important",
    // maxWidth: "200px",
  },
  ".comp-editable > tr > td:last-of-type": {
    paddingRight: "24px",
    paddingLeft: "10px !important",
  },
  ".comp-editable > tr > th": {
    paddingRight: "0px",
    paddingLeft: "10px",
  },
  ".comp-editable > tr > th:first-of-type": {
    paddingRight: "24px",
    paddingLeft: "24px !important",
    // minWidth: "250px",
  },
  ".comp-editable > tr > th:last-of-type": {
    paddingRight: "24px",
    paddingLeft: "10px !important",
  },

  ".market-editable > tr > td": {
    paddingRight: "0px",
    paddingLeft: "10px",
    // width: "auto !important",
  },
  ".market-editable > tr > td > div:has(.translations-cell)": {
    width: "100% !important",
  },
  ".market-editable > tr > td:first-of-type": {
    paddingRight: "24px",
    paddingLeft: "24px !important",
    // maxWidth: "200px !important",
    width: "min-content",
  },
  ".market-editable > tr > td:first-of-type > div": {
    // width: "auto !important",
    // maxWidth: "200px",
  },
  ".market-editable > tr > td:last-of-type": {
    paddingRight: "24px",
    paddingLeft: "10px !important",
  },
  ".market-editable > tr > th": {
    paddingRight: "0px",
    paddingLeft: "10px",
  },
  ".market-editable > tr > th:first-of-type": {
    paddingRight: "24px",
    paddingLeft: "24px !important",
    // minWidth: "250px",
  },
  ".market-editable > tr > th:last-of-type": {
    paddingRight: "24px",
    paddingLeft: "10px !important",
  },

  ".participant-editable > tr > td": {
    paddingRight: "0px",
    paddingLeft: "10px",
    // width: "auto !important",
  },
  ".participant-editable > tr > td > div": {
    width: "100% !important",
  },
  ".participant-editable > tr > td:first-of-type": {
    paddingRight: "24px",
    paddingLeft: "24px !important",
    // maxWidth: "200px !important",
    width: "min-content",
  },
  ".participant-editable > tr > td:first-of-type > div": {
    // width: "auto !important",
    // maxWidth: "200px",
  },
  ".participant-editable > tr > td:last-of-type": {
    paddingRight: "24px",
    paddingLeft: "10px !important",
  },
  ".participant-editable > tr > th": {
    paddingRight: "0px",
    paddingLeft: "10px",
  },
  ".participant-editable > tr > th:first-of-type": {
    paddingRight: "24px",
    paddingLeft: "24px !important",
    // minWidth: "250px",
  },
  ".participant-editable > tr > th:last-of-type": {
    paddingRight: "24px",
    paddingLeft: "10px !important",
  },

  ".conflicts > tr > th": {
    paddingRight: "5px",
    paddingLeft: "10px !important",
  },

  ".conflicts > tr > td": {
    paddingRight: "5px",
    paddingLeft: "10px !important",
  },

  ".conflicts > tr > td:last-of-type": {
    padding: "0px !important",
  },

  ".conflicts > tr > td:last-of-type > div": {
    width: "100%",
  },

  ".conflicts > tr > td:last-of-type > div > div > p > p:last-of-type": {
    minWidth: "200px",
  },

  ".to-edit:hover + .hidden, .hidden:hover": {
    visibility: "visible",
    marginLeft: "-5px",
  },
  ".hidden": {
    visibility: "hidden",
  },
  ".opacity-revert": {
    opacity: "100% !important",
  },
  ".form-label": {
    margin: 0,
    fontSize: "0.75rem",
    fontWeight: "400",
    lineHeight: "1.25",
    letterSpacing: "0.03333em",
    opacity: 1,
    textTransform: "capitalize",
    verticalAlign: "unset",
    textDecoration: "none",
    color: "#344767",
    fontWeight: 700,
  },
  ".form-info": {
    fontSize: "0.75rem !important",
    opacity: "0.5 !important",
  },

  ".secondary-menu-fixed-settlement": {
    position: "fixed",
    top: "105px",
    // left: "300px",
    width: "250px",
    paddingLeft: "0px !important",
    height: "calc(100% - 150px)",
  },

  ".secondary-menu-fixed-settlement > div": {
    height: "max-content",
    maxHeight: "100%",
  },

  ".scrolling-main-page-settlement": {
    // left: "420px",
    position: "relative",
    overflow: "auto",
    height: "100%",
    maxHeight: "calc(100vh - 120px)",
    scrollbarWidth: "none",
    paddingRight: "20px",
    marginTop: "24px !important",
    marginLeft: "260px !important",
    width: "100%",
    paddingTop: "0px !important",
    flexBasis: "100% !important",
    maxWidth: "100% !important",
    height: "calc(100vh - 120px) !important",
  },

  ".settlement-page-holder": {
    width: "100%",
  },

  "#table_container": {
    overflowX: "none",
    minHeight: "350px",
  },

  ".advanced-settlement-table > #table_body": {
    overflowX: "auto",
  },

  ".confirmation-settlement-table > #table_body": {
    overflowX: "auto",
  },

  ".advanced-riskmanagement-table > #table_body": {
    overflowX: "auto",
  },

  ".bet-open": {
    color: "rgb(203, 12, 159)",
  },

  ".bet-won": {
    color: "orange",
  },

  ".bet-lost": {
    color: "green",
  },

  "#table_body": {
    minHeight: "150px",
  },

  ".advanced-settlement-table": {
    // maxHeight: "calc(100vh - 380px)",
    minHeight: "100%",
    //height: "calc(100vh - 380px)",
    // display: "grid !important",
    // overflowY: "auto",
    // overflowX: "auto",
    display: "-webkit-box !important",
    overflowX: "auto",
    scrollbarWidth: "thin !important",
  },

  ".advanced-riskmanagement-table": {
    // maxHeight: "calc(100vh - 470px)",
    minHeight: "100%",
    //height: "calc(100vh - 380px)",
    // display: "grid !important",
    // overflowY: "auto",
    // overflowX: "auto",
    display: "-webkit-box !important",
    overflowX: "auto",
    scrollbarWidth: "thin !important",
  },

  // ".advanced-riskmanagement-table > tbody > tr:nth-child(even)": {
  //   backgroundColor: "#dbf7db !important",
  // },

  ".odd-row": {
    backgroundColor: "#ffffff",
    borderTop: "0.0625rem solid #e9ecef",
    display: "block !important",
  },

  ".even-row": {
    backgroundColor: "#f8f9fa",
    borderTop: "0.0625rem solid #e9ecef",
    display: "block !important",
  },

  ".collapsable-row-table": {
    backgroundColor: "#f8f9fa",
  },

  ".collapsable-row-table #table_container": {
    minHeight: "280px",
    boxShadow: "0rem 0rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
  },

  ".advanced-riskmanagement-table > thead > tr": {
    display: "block !important",
  },

  ".advanced-riskmanagement-table > thead > tr > th": {
    minWidth: "50px !important",
    paddingRight: "24px !important",
    paddingLeft: "24px !important",
    textAlign: "right",
    width: "fit-content",
    borderRight: "1px solid #f8fafb",
  },

  ".advanced-riskmanagement-table > thead > tr > th:nth-of-type(1) > div": {
    width: "28px !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td": {
    borderRight: "1px solid transparent",
  },

  ".advanced-riskmanagement-table > tbody > tr.collapsable-row-table > td": {
    borderRight: "unset !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(1) > div": {
    width: "28px !important",
    textAlign: "center",
  },

  ".advanced-riskmanagement-table > tbody > tr.collapsable-row-table > td > div": {
    width: "unset !important",
    textAlign: "unset !important",
  },

  ".advanced-riskmanagement-table > thead > tr > th:nth-of-type(2) > div": {
    width: "80px !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(2) > div": {
    width: "80px !important",
    textAlign: "center",
  },

  ".advanced-riskmanagement-table > thead > tr > th:nth-of-type(3) > div": {
    width: "60px !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(3) > div": {
    width: "60px !important",
    textAlign: "center",
  },

  ".advanced-riskmanagement-table > thead > tr > th:nth-of-type(4) > div": {
    width: "60px !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(4) > div": {
    width: "60px !important",
    textAlign: "center",
  },

  ".advanced-riskmanagement-table > thead > tr > th:nth-of-type(5) > div": {
    width: "80px !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(5) > div": {
    width: "80px !important",
    textAlign: "center",
  },

  ".advanced-riskmanagement-table > thead > tr > th:nth-of-type(6) > div": {
    width: "80px !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(6) > div": {
    width: "80px !important",
    textAlign: "center",
  },

  ".advanced-riskmanagement-table > thead > tr > th:nth-of-type(7) > div": {
    width: "160px !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(7) > div": {
    width: "160px !important",
    textAlign: "center",
  },

  ".advanced-riskmanagement-table > thead > tr > th:nth-of-type(8) > div": {
    width: "160px !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(8) > div": {
    width: "160px !important",
    textAlign: "center",
  },

  ".advanced-riskmanagement-table > thead > tr > th:nth-of-type(9) > div": {
    width: "100px !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(9) > div": {
    width: "100px !important",
    textAlign: "center",
  },

  ".advanced-riskmanagement-table > thead > tr > th:nth-of-type(10) > div": {
    width: "100px !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(10) > div": {
    width: "100px !important",
    textAlign: "center",
  },

  ".advanced-riskmanagement-table > thead > tr > th:nth-of-type(11) > div": {
    width: "100px !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(11) > div": {
    width: "100px !important",
    textAlign: "center",
  },

  ".advanced-riskmanagement-table > thead > tr > th:nth-of-type(12) > div": {
    width: "100px !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(12) > div": {
    width: "100px !important",
    textAlign: "center",
  },

  ".advanced-riskmanagement-table > thead > tr > th:nth-of-type(13) > div": {
    width: "50px !important",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(13) > div": {
    width: "50px !important",
    textAlign: "center",
  },

  ".collapsable-row-table #zero-data": {
    zIndex: "-1 !important",
  },

  ".confirmation-settlement-table": {
    maxHeight: "calc(100vh - 380px)",
    minHeight: "100%",
    display: "-webkit-box !important",
    overflowX: "auto",
    scrollbarWidth: "thin !important",
  },

  ".confirmation-button": {
    border: "1px solid #e9ecef !important",
    borderRadius: "50px !important",
    width: "2rem !important",
    padding: "0px !important",
    marginLeft: "15px !important",
    marginTop: "15px !important",
    marginBottom: "15px !important",
    minWidth: "0px !important",
    height: "2rem !important",
    backgroundColor: "#edf0f2 !important",
    boxShadow: "0px 0px 3px #a5afc2 !important",
  },

  ".radio-confirmation-button": {
    // border: "1px solid #e9ecef !important",
    // borderRadius: "50px !important",
    width: "2rem !important",
    padding: "0px !important",
    marginLeft: "15px !important",
    marginTop: "0px !important",
    marginBottom: "0px !important",
    minWidth: "0px !important",
    // height: "2rem !important",
    // backgroundColor: "#edf0f2 !important",
    // boxShadow: "0px 0px 3px #a5afc2 !important",
  },

  ".remove-confirmation-button": {
    width: "2rem !important",
    padding: "0px !important",
    marginLeft: "15px !important",
    marginTop: "0px !important",
    marginBottom: "0px !important",
    minWidth: "0px !important",
    color: "red !important",
  },

  ".remove-confirmation-button > span": {
    fontSize: "1.25rem !important",
    fontWeight: "600 !important",
  },

  ".confirmed-button": {
    width: "2rem !important",
    padding: "0px !important",
    marginLeft: "15px !important",
    marginTop: "15px !important",
    marginBottom: "15px !important",
    minWidth: "0px !important",
    height: "2rem !important",
  },

  ".confirmation-button-blocked": {
    width: "2rem !important",
    padding: "0px !important",
    marginLeft: "15px !important",
    marginTop: "15px !important",
    marginBottom: "15px !important",
    minWidth: "0px !important",
    height: "2rem !important",
  },

  ".multilineTextField > div": {
    border: "0px",
    borderBottom: "1px solid #cecece",
    borderRadius: "0px !important",
    backgroundColor: "transparent !important",
  },

  "[id^='outlined-multiline-flexible']": {
    scrollbarWidth: "thin",
  },

  ".multilineTextField > label": {
    fontSize: "1rem",
    color: "#cecece",
  },

  ".advanced-settlement-table > tbody > tr > td": {
    paddingRight: "12px !important",
    paddingLeft: "12px !important",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(1)": {
    backgroundColor: "#e9ecef66",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(6)": {
    backgroundColor: "rgba(251, 243, 211, 0.44)",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(7)": {
    backgroundColor: "rgba(251, 243, 211, 0.66)",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    paddingRight: "0px !important",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(8)": {
    paddingRight: "0px !important",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(9)": {
    backgroundColor: "#e9ecef33",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(10)": {
    backgroundColor: "#fbf3d333",
    borderLeft: "0px solid #e9ecef",
    borderRight: "0px solid #e9ecef",
  },

  // ".advanced-settlement-table > tbody > tr > td:nth-of-type(8)": {
  //   backgroundColor: "#e9ecef66",
  //   borderLeft: "1px solid #e9ecef",
  //   borderRight: "1px solid #e9ecef",
  // },
  // ".advanced-settlement-table > tbody > tr > td:nth-of-type(9)": {
  //   backgroundColor: "#e9ecef33",
  // },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(11)": {
    backgroundColor: "#fbf3d333",
    borderLeft: "0px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(12)": {
    backgroundColor: "#e9ecef33",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(13)": {
    backgroundColor: "#e9ecef33",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(14)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    textWrap: "wrap",
    width: "100px",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(14) > div": {
    textWrap: "inherit",
    width: "inherit",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(15)": {
    backgroundColor: "#e9ecef66",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(16)": {
    backgroundColor: "#e9ecef66",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(17)": {
    backgroundColor: "#e9ecef33",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(18)": {
    backgroundColor: "#e9ecef33",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(18) > div": {
    color: "rgb(203, 12, 159) !important",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(19)": {
    backgroundColor: "#e9ecef33",
    borderLeft: "1px solid #e9ecef",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(19) > div": {
    color: "rgb(203, 12, 159) !important",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(20)": {
    backgroundColor: "#e9ecef66",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    // paddingRight: "0px !important",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(21)": {
    backgroundColor: "#fbf3d333",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(22)": {
    backgroundColor: "#e9ecef33",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(22) > div": {
    color: "rgb(203, 12, 159) !important",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(23)": {
    backgroundColor: "#f7c2a333",
    borderRight: "1px solid #e9ecef",
    paddingRight: "0px !important",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(23) > div": {
    color: "rgb(203, 12, 159) !important",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(24)": {
    backgroundColor: "#fbf3d333",
    borderLeft: "1px solid #e9ecef",
    // textWrap: "wrap",
    // width: "100px",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(24) > div": {
    // textWrap: "inherit",
    // width: "inherit",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(25)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
    textWrap: "wrap",
    width: "100px",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(25) > div": {
    textWrap: "inherit",
    width: "inherit",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(26)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(27)": {
    backgroundColor: "#fbf3d3",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(28)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(29)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(30)": {
    backgroundColor: "#fbf3d3",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-settlement-table > tbody > tr > td:nth-of-type(31)": {
    backgroundColor: "rgba(197, 226, 255, 0.2)",
    borderRight: "1px solid #e9ecef",
  },

  ".advanced-settlement-table > tbody > tr > td:nth-of-type(32)": {
    backgroundColor: "rgba(251, 243, 211, 0.44)",
    borderLeft: "1px solid #e9ecef",
  },

  //------------------------

  ".noteHolder": {
    maxWidth: "140px",
  },

  ".noteHolder > div": {
    marginRight: "0px !important",
    paddingRight: "0px !important",
    height: "fit-content !important",
  },

  ".notes-download": {
    padding: "0px !important",
    width: "30px !important",
    minWidth: "30px !important",
  },

  ".sync-notes-button": {
    fontSize: "0.65rem !important",
  },

  ".settlements-popover > div:nth-of-type(3)": {
    height: "550px !important",
  },

  ".outrights-cell-width": {
    maxWidth: "120px",
    overflowWrap: "break-word",
  },

  ".outrights-matched": {
    color: "rgb(203, 12, 159) !important",
    fontSize: "0.7rem !important",
    paddingRight: "0px !important",
  },

  ".outrights-unmatched": {
    color: "#637eb3 !important",
    fontSize: "0.7rem !important",
    paddingRight: "0px !important",
  },

  ".outrights-sp-value": {
    maxWidth: "50px",
    padding: "5px 5px 5px 10px !important",
  },

  ".outrights-settlement-table > tbody > tr > td": {
    paddingRight: "12px !important",
    paddingLeft: "12px !important",
  },

  ".outrights-settlement-table > tbody > tr > td:nth-of-type(2)": {
    // backgroundColor: "#e9ecef66",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },

  ".outrights-settlement-table > tbody > tr > td:nth-of-type(3)": {
    backgroundColor: "#e9ecef33",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },
  ".outrights-settlement-table > tbody > tr > td:nth-of-type(4)": {
    backgroundColor: "#fbf3d333",
    borderLeft: "0px solid #e9ecef",
    borderRight: "0px solid #e9ecef",
    fontSize: "0.7rem !important",
  },
  ".outrights-settlement-table > tbody > tr > td:nth-of-type(5)": {
    backgroundColor: "#fbf3d333",
    borderLeft: "0px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    fontSize: "0.7rem !important",
  },

  ".outrights-settlement-table > tbody > tr > td:nth-of-type(6)": {
    backgroundColor: "rgba(251, 243, 211, 0.44)",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },

  ".outrights-settlement-table > tbody > tr > td:nth-of-type(7)": {
    backgroundColor: "#fbf3d3",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    paddingRight: "0px !important",
  },

  ".outrights-settlement-table > tbody > tr > td:nth-of-type(8)": {
    backgroundColor: "rgba(251, 243, 211, 0.66)",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    paddingRight: "0px !important",
  },

  ".outrights-settlement-table > tbody > tr > td:nth-of-type(9)": {
    fontSize: "0.8rem !important",
  },

  ".outrights-settlement-table > tbody > tr > td:nth-of-type(10)": {
    borderLeft: "1px solid #e9ecef",
    backgroundColor: "#e9ecef33",
    paddingRight: "0px !important",
  },
  ".outrights-settlement-table > tbody > tr > td:nth-of-type(11)": {
    paddingLeft: "0px !important",
    backgroundColor: "#e9ecef33",
  },

  ".outrights-settlement-table > tbody > tr > td:nth-of-type(12)": {
    backgroundColor: "#e9ecef33",
    maxWidth: "140px",
    paddingLeft: "0px !important",
  },
  ".outrights-settlement-table > tbody > tr > td:nth-of-type(13)": {
    backgroundColor: "#e9ecef33",
    paddingRight: "0px !important",
  },
  ".outrights-settlement-table > tbody > tr > td:nth-of-type(14)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    textWrap: "wrap",
    fontSize: "0.7rem",
  },

  ".outrights-settlement-table > tbody > tr > td:nth-of-type(14) > div": {
    textWrap: "inherit",
    width: "inherit",
  },

  //------------------------

  ".bet-odd-settlement-outcomes > div:nth-of-type(1)": {
    height: "1.5rem !important",
    backgroundColor: "#fff !important",
    borderRadius: "10px",
  },

  ".confirmation-settlement-table > thead > tr > td:nth-of-type(1)": {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },

  ".confirmation-settlement-table > thead > tr > td:nth-of-type(2)": {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },

  ".confirmation-settlement-table > thead > tr > td:nth-of-type(3)": {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },

  ".confirmation-settlement-table > thead > tr > td:nth-of-type(4)": {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },

  ".confirmation-settlement-table > thead > tr > td:nth-of-type(5)": {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },

  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(1)": {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(2)": {
    backgroundColor: "#fbf3d3",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(3)": {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(4)": {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(5)": {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(6)": {
    backgroundColor: "#fbf3d370",
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(7)": {
    backgroundColor: "#e9ecef66",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    textAlign: "center",
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },
  // ".confirmation-settlement-table > tbody > tr > td:nth-of-type(8)": {
  //   backgroundColor: "#e9ecefc9",
  //   borderLeft: "1px solid #e9ecef",
  //   borderRight: "1px solid #e9ecef",
  //   textAlign: "center",
  //   paddingLeft: "12px !important",
  //   paddingRight: "12px !important",
  // },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(8)": {
    backgroundColor: "#e9ecef33",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    textAlign: "center",
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(8) .confirm-conflict": {
    color: "orange",
    fontSize: "1.45rem !important",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(8) .confirm-passed": {
    color: "green",
    fontSize: "1.45rem !important",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(8) .confirm-blocked": {
    color: "red",
    // cursor: "not-allowed !important",
    opacity: "40% !important",
    pointerEvents: "all !important",
    fontSize: "1.75rem !important",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(8) .confirm-confirmed": {
    color: "green",
    cursor: "not-allowed !important",
    opacity: "40% !important",
    pointerEvents: "all !important",
    fontSize: "1.45rem !important",
  },

  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(8) > div > p > span": {},
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(8):hover": {
    // cursor: "pointer",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(8):hover > div > p > span": {
    color: "#95dc39",
    // cursor: "pointer",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(9)": {
    backgroundColor: "#c5e2ff33",
    fontSize: "0.75rem",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(10)": {
    backgroundColor: "#fbf3d370",
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(13)": {
    backgroundColor: "#e9ecef33",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(14)": {
    backgroundColor: "#e9ecef33",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(15)": {
    backgroundColor: "#e9ecef33",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(16)": {
    backgroundColor: "#e9ecef66",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(17)": {
    backgroundColor: "#fbf3d333",
    borderLeft: "1px solid #e9ecef",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(18)": {
    backgroundColor: "#fbf3d333",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(19)": {
    backgroundColor: "#fbf3d333",
    borderRight: "1px solid #e9ecef",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(20) > div": {
    color: "rgb(203, 12, 159) !important",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(21)": {
    backgroundColor: "#fbf3d333",
    borderLeft: "1px solid #e9ecef",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(22)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(23)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
  },
  ".confirmation-settlement-table > tbody > tr > td:nth-of-type(24)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
  },

  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(8)": {
    backgroundColor: "rgba(251, 243, 211, 0.66)",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },
  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(9)": {
    backgroundColor: "rgba(251, 243, 211, 0.33)",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },
  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(10)": {
    backgroundColor: "rgba(251, 243, 211, 0.33)",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },
  ".advanced-riskmanagement-table > tbody > tr > td:nth-of-type(11)": {
    backgroundColor: "rgba(251, 243, 211, 0.33)",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:has(div > div.blocked)": {
    backgroundColor: "#fb8e9866",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(1)": {
    backgroundColor: "rgba(251, 243, 211, 0.66)",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(2)": {
    backgroundColor: "#c5e2ff33",
    fontSize: "0.75rem",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    width: "100% !important",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(2) > div": {
    width: "100% !important",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(3)": {
    backgroundColor: "rgba(251, 243, 211, 0.66)",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    maxWidth: "150px !important",
    minWidth: "150px !important",
    textWrap: "wrap !important",
    width: "150px !important",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(3) > div": {
    maxWidth: "150px !important",
    minWidth: "150px !important",
    textWrap: "wrap !important",
    width: "150px !important",
    display: "contents",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(4)": {},

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(5)": {},

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(6)": {},

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(4) > div": {
    minWidth: "60px !important",
    textWrap: "wrap !important",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(5) > div": {
    minWidth: "60px !important",
    textWrap: "wrap !important",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(6) > div": {
    minWidth: "60px !important",
    textWrap: "wrap !important",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(7)": {
    backgroundColor: "#fbf3d370",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(8)": {
    backgroundColor: "#e9ecef66",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(9)": {
    backgroundColor: "#e9ecef33",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(10)": {
    backgroundColor: "#e9ecef66",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
    minWidth: "180px !important",
    maxWidth: "180px !important",
    width: "180px !important",
  },

  // ".advanced-settlement-table > tbody > tr > td:nth-of-type(8)": {
  //   backgroundColor: "#e9ecef66",
  //   borderLeft: "1px solid #e9ecef",
  //   borderRight: "1px solid #e9ecef",
  // },
  // ".advanced-settlement-table > tbody > tr > td:nth-of-type(9)": {
  //   backgroundColor: "#e9ecef33",
  // },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(11)": {
    backgroundColor: "#e9ecef33",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(12)": {
    backgroundColor: "#e9ecef33",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(12) > div": {
    minWidth: "80px",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(13)": {
    backgroundColor: "#e9ecef33",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(14)": {
    backgroundColor: "#e9ecef33",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(15)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
  },
  // ".advanced-settlement-table > tbody > tr > td:nth-of-type(15)": {
  //   backgroundColor: "#e9ecef33",
  // },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(16)": {
    backgroundColor: "#e9ecef66",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(18)": {
    backgroundColor: "#f7c2a333",
    borderLeft: "1px solid #e9ecef",
  },

  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(19)": {
    backgroundColor: "#fbf3d333",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(20)": {
    backgroundColor: "#fbf3d333",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(20) > div": {
    color: "rgb(203, 12, 159) !important",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(21)": {
    backgroundColor: "#fbf3d333",
    borderRight: "1px solid #e9ecef",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(22)": {
    backgroundColor: "#fbf3d333",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(23)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(24)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(25)": {
    backgroundColor: "#fbf3d3",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(26)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(27)": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
  },
  ".advanced-riskmanagement-table-betodds > tbody > tr > td:nth-of-type(28)": {
    backgroundColor: "#fbf3d3",
    borderLeft: "1px solid #e9ecef",
  },

  ".live-settlement-table > tbody > tr > td:nth-of-type(2) ": {
    backgroundColor: "#fbf3d3",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },

  ".live-settlement-table > tbody > tr > td:nth-of-type(6) ": {
    backgroundColor: "#fbf3d370",
    borderLeft: "1px solid #e9ecef",
    borderRight: "1px solid #e9ecef",
  },

  ".coverage-lost-results thead": {
    backgroundColor: "grey",
    color: "white",
  },

  ".coverage-lost-results tr:nth-of-type(even)": {
    backgroundColor: "#e6e6e6",
  },

  ".settlement-fixtures-list td": {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
  },

  // ".settlement-fixtures-list td:first-of-type": {
  //   paddingLeft: "24px !important",
  //   paddingRight: "24px !important",
  // },
  ".signal-data-processed": {
    maxWidth: "500px",
  },

  ".secondary-menu-fixed": {
    position: "fixed",
    top: "105px",
    // left: "300px",
    width: "420px",
    paddingLeft: "0px !important",
  },

  ".scrolling-main-page": {
    // left: "420px",
    position: "relative",
    overflow: "auto",
    height: "100%",
    maxHeight: "calc(100vh - 180px)",
    scrollbarWidth: "none",
    paddingRight: "20px",
    marginTop: "24px !important",
    marginLeft: "420px !important",
  },
  ".list-item-disabled > span": {
    fontSize: "0.85rem",
    opacity: "0.5",
  },
  ".list-item > span": {
    fontSize: "0.85rem",
  },
  ".list-item-checkbox": {
    width: "1rem !important",
    height: "1rem !important",
  },
  ".code-holder": {
    paddingLeft: "2%",
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.5,
  },
  pre: {
    position: "relative",
    display: "block",
    padding: "8px 12px",
    margin: "0 0 8px",
    marginTop: "0px",
    marginBottom: "8px",
    fontSize: "0.875rem",
    wordBreak: "break-all",
    wordWrap: "break-word",
    backgroundColor: "#fbfafd",
    border: "1px solid #dcdcde",
    borderRadius: "2px",
    marginBottom: "16px",
    lineHeight: "1.6em",
    overflowX: "auto",
    borderRadius: "4px",
  },

  code: {
    padding: "2px 4px",
    color: "#1f1e24",
    backgroundColor: "#ececef",
    borderRadius: "4px",
  },

  "pre > code": {
    backgroundColor: "inherit",
    padding: "unset",
  },

  ".code-holder code": {
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    wordBreak: "keep-all",
    fontSize: "0.875rem",
  },

  ".code-holder h1": {
    fontSize: "1.75em",
    fontWeight: "600",
    margin: "24px 0 16px",
    marginTop: "24px",
    paddingBottom: "0.3em",
    borderBottom: "1px solid #e6e6ea",
  },

  ".code-holder h2": {
    fontSize: "1.5em",
    fontWeight: "600",
    margin: "24px 0 16px",
    paddingBottom: "0.3em",
    borderBottom: "1px solid #e6e6ea",
  },
  ".code-holder h3": {
    margin: "24px 0 16px",
    fontSize: "1.3em",
    fontWeight: "600",
    lineHeight: "1.2",
  },
  ".code-holder h4": {
    fontSize: "1.15em",
    fontWeight: "600",
    margin: "24px 0 16px",
    paddingBottom: "0.3em",
    borderBottom: "1px solid #e6e6ea",
  },
  ".code-holder h5": {
    fontSize: "1em",
    fontWeight: "600",
    margin: "24px 0 16px",
    paddingBottom: "0.3em",
    borderBottom: "1px solid #e6e6ea",
  },

  ".code-holder > ul": {
    listStyleType: "disc",
  },

  ".code-holder ul, .md ol": {
    padding: 0,
    margin: "0 0 16px",
  },

  ".code-holder li": {
    marginLeft: "28px",
    paddingLeft: 0,
  },
  ".code-holder li": {
    lineHeight: "1.6em",
    marginLeft: "25px",
    paddingLeft: "3px",
  },
  ".code-holder p": {
    marginBottom: "15px",
  },
  iframe: {
    width: "100%",
    height: "70vh",
    border: "none",
    borderRadius: "0px 0px 20px 20px",
  },
  ".play-action:hover": {
    color: "rgba(106, 183, 10, 0.3)",
  },
  ".stop-action:hover": {
    color: "rgba(247, 104, 104, 0.3)",
  },
  ".snapshot-action:hover": {
    color: "#cb0c9f30",
  },
  ".block-bets-action: hover": {
    color: "#cb0c9f30",
  },

  ".badge-success": {
    minHeight: "fit-content !important",
    height: "auto !important",
    padding: "0.575em 0.775em 0.4em !important",
    fontSize: "0.65rem !important",
    fontWeight: "700 !important",
    textTransform: "uppercase !important",
    lineHeight: 1,
    textAlign: "center !important",
    whiteSpace: "nowrap !important",
    verticalAlign: "baseline !important",
    border: "none !important",
    borderRadius: "0.25rem !important",
    background: "#cdf59b !important",
    color: "#67b108 !important",
    position: "relative !important",
    transform: "none !important",
    boxShadow: "0px 0px aliceblue !important",
    lineHeight: "1 !important",
  },
  ".badge-success:hover": {
    background: "#cdf59b80 !important",
    color: "#67b10880 !important",
  },
  ".badge-error": {
    minHeight: "fit-content !important",
    height: "auto !important",
    padding: "0.575em 0.775em 0.4em !important",
    fontSize: "0.65rem !important",
    fontWeight: "700 !important",
    textTransform: "uppercase !important",
    lineHeight: 1,
    textAlign: "center !important",
    whiteSpace: "nowrap !important",
    verticalAlign: "baseline !important",
    border: "none !important",
    borderRadius: "0.25rem !important",
    background: "#fc9797 !important",
    color: "#bd0000 !important",
    position: "relative !important",
    transform: "none !important",
    boxShadow: "0px 0px aliceblue !important",
    lineHeight: "1 !important",
  },
  ".badge-error:hover": {
    background: "#fc979780 !important",
    color: "#bd000080 !important",
  },

  ".api-success-notifications": {
    backgroundColor: "#f6fded !important",
    color: "#8392ab !important",
  },
  ".api-info-notifications": {
    backgroundColor: "#edfcfd !important",
    color: "#8392ab !important",
  },
  ".api-error-notifications": {
    backgroundColor: "#fdeded !important",
    color: "#8392ab !important",
  },
  ".custom-progress-vbet > span": {
    background: "linear-gradient(310deg, #a71f67, #D22782) !important",
  },
  ".custom-progress-1xbet > span": {
    background: "linear-gradient(310deg, #002F5E, #007ACC) !important",
  },
  ".custom-progress-bet365 > span": {
    background: "linear-gradient(310deg, #1a5524, #349e46) !important",
  },
  ".custom-progress-betanode > span": {
    background: "linear-gradient(310deg, #C74F00, #ff6600) !important",
  },
  ".custom-progress-stoiximan > span": {
    background: "linear-gradient(310deg, #174bad, #007aff) !important",
  },
  ".custom-progress-williamhill > span": {
    background: "linear-gradient(310deg, #0052a5, #1697D0) !important",
  },
  ".custom-progress-mozzartbet > span": {
    background: "linear-gradient(310deg, #0052a5, #1697D0) !important",
  },
  ".custom-progress-betradar > span": {
    background: "linear-gradient(310deg, #0052a5, #1697D0) !important",
  },
  ".custom-progress-draftkings > span": {
    background: "linear-gradient(310deg, #61b510, #b0da87) !important",
  },
  ".custom-progress-bwin > span": {
    background: "linear-gradient(310deg, #000000, #cecece) !important",
  },
  ".custom-progress-paddypower > span": {
    background: "linear-gradient(310deg, #0e4c40, #cecece) !important",
  },

  ".custom-progress-sbobet > span": {
    background: "linear-gradient(310deg, #001e60, #cecece) !important",
  },
  ".custom-progress-188bet > span": {
    background: "linear-gradient(310deg, #f08b00, #cecece) !important",
  },
  ".custom-progress-unibet > span": {
    background: "linear-gradient(310deg, #147b44, #cecece) !important",
  },
  ".custom-progress-sportingbet > span": {
    background: "linear-gradient(310deg, #6bbff6, #cecece) !important",
  },

  ".MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected": {
    backgroundColor: "#17c1e8a3 !important",
    color: "#fff !important",
  },
  ".sticky-header": {
    position: "sticky",
    top: "0px",
    background: "#f6f7f9 !important",
    boxShadow: "5px 2px 5px gray !important",
    zIndex: "1",
  },

  "#settlement-filters-header": {
    backgroundColor: "#e9ecef38",
    borderRadius: "16px 16px 0px 0px",
  },
  "#settlement-filters-content": {
    padding: "20px",
  },
  "#platforms-filter": {
    width: "max-content",
    minWidth: "240px",
  },
  "#sport-filter": {
    width: "max-content",
    minWidth: "240px",
  },
  "#markets-type-filter": {
    width: "max-content",
  },
  "#markets-status-filter": {
    width: "max-content",
  },
  "#user-option": {
    width: "max-content",
    minWidth: "240px",
  },
  "#trans-sport-filter": {
    width: "100%",
    minWidth: "240px",
    zIndex: 1000,
  },
  ".platform-filter-group": {
    backgroundColor: "#f9f9f980",
    margin: "auto",
    paddingBottom: "40px",
  },
  ".fixture-filter-group": {
    backgroundColor: "#fff",
    margin: "auto",
    paddingBottom: "40px",
    borderTop: "1px solid #eaeaea",
  },
  ".bet-filter-group": {
    backgroundColor: "#f9f9f980",
    margin: "auto",
    paddingBottom: "40px",
    borderTop: "1px solid #eaeaea",
  },
  ".betbuilder-filter-group": {
    backgroundColor: "#f9f9f980",
    margin: "auto",
    paddingBottom: "40px",
    borderTop: "1px solid #eaeaea",
  },
  ".settlement-filter-group": {
    backgroundColor: "#fff",
    margin: "auto",
    paddingBottom: "20px",
    borderTop: "1px solid #eaeaea",
  },
  "#bet-status, #bet-date-filter, #betbuilder-status, #betbuilder-date-filter": {
    backgroundColor: "#fff",
    // minWidth: "max-content",
  },
  "#platforms-filter": {
    backgroundColor: "#fff",
    width: "fit-content",
    minWidth: "30%",
  },
  "odd-holder": {
    minWidth: "60px",
  },
  ".odd-name": {
    fontSize: "0.85rem !important",
    textAlign: "center",
    width: "100%",
    minWidth: "60px",
  },
  ".odd": {
    fontSize: "0.85rem !important",
    minWidth: "30px",
    textAlign: "center",
    width: "100%",
  },
  ".odd-seperator": {
    fontWeight: "bold",
    fontSize: "0.85rem",
    paddingLeft: "5px",
    paddingRight: "5px",
    lineHeight: "1 !important",
    color: "#cecece !important",
  },
  ".odd-deleted": {
    color: "#cecece !important",
  },
  ".odd-new": {},
  ".odd-updated": {
    color: "green !important",
  },
  ".odd-suspended": {
    color: "#cecece !important",
  },
  ".league-cell": {
    maxWidth: "120px !important",
    wordWrap: "normal",
  },
  ".date-cell": {
    maxWidth: "120px !important",
    wordWrap: "normal",
  },
  ".markets-cell": {
    width: "100%",
    textAlign: "center",
    minWidth: "100px",
  },
  ".competition-cell": {
    maxWidth: "120px !important",
    wordWrap: "normal",
  },
  ".platform_names-cell": {
    maxWidth: "120px !important",
    wordWrap: "normal",
  },
  ".user_agent-cell": {
    maxWidth: "420px !important",
    wordWrap: "normal",
  },
  ".market-match-result": {
    width: "100%",
    paddingLeft: "0px !important",
    paddingRight: "0px !important",
  },
  ".marketGroup": {
    fontSize: "0.7rem !important",
    minWidth: "44px!important",
  },
  ".marketGroup:hover": {
    fontSize: "0.7rem !important",
    minWidth: "44px!important",
  },
  ".marketGroup:selected": {
    fontSize: "0.7rem !important",
    minWidth: "44px!important",
  },
  ".provider-competition": {
    color: "",
  },
  ".provider-vbet-competition": {
    color: customColors["vbet"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-stoiximan-competition": {
    color: customColors["stoiximan"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-1xbet-competition": {
    color: customColors["1xbet"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-williamhill-competition": {
    color: customColors["williamhill"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-mozzartbet-competition": {
    color: customColors["mozzartbet"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-betradar-competition": {
    color: customColors["betradar"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-bet365-competition": {
    color: customColors["bet365"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-betanode-competition": {
    color: customColors["betanode"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-draftkings-competition": {
    color: customColors["draftkings"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-bwin-competition": {
    color: customColors["bwin"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-paddypower-competition": {
    color: customColors["paddypower"],
    textShadow: "0px 0px 5px #cececece",
  },

  ".provider-188bet-competition": {
    color: customColors["188bet"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-sbobet-competition": {
    color: customColors["sbobet"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-unibet-competition": {
    color: customColors["unibet"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-sportingbet-competition": {
    color: customColors["sportingbet"],
    textShadow: "0px 0px 5px #cececece",
  },

  ".provider-vbet": {
    color: customColors["vbet"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-stoiximan": {
    color: customColors["stoiximan"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-1xbet": {
    color: customColors["1xbet"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-williamhill": {
    color: customColors["williamhill"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-mozzartbet": {
    color: customColors["mozzartbet"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-betradar": {
    color: customColors["betradar"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-bet365": {
    color: customColors["bet365"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-betanode": {
    color: customColors["betanode"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-draftkings": {
    color: customColors["draftkings"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-bwin": {
    color: customColors["bwin"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-paddypower": {
    color: customColors["paddypower"],
    textShadow: "0px 0px 5px #cececece",
  },

  ".provider-188bet": {
    color: customColors["188bet"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-sbobet": {
    color: customColors["sbobet"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-unibet": {
    color: customColors["unibet"],
    textShadow: "0px 0px 5px #cececece",
  },
  ".provider-sportingbet": {
    color: customColors["sportingbet"],
    textShadow: "0px 0px 5px #cececece",
  },

  ".provider-vbet-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["vbet"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-stoiximan-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["stoiximan"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-1xbet-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["1xbet"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-williamhill-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["williamhill"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-mozzartbet-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["mozzartbet"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-betradar-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["betradar"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-bet365-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["bet365"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-betanode-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["betanode"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-draftkings-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["draftkings"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-bwin-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["bwin"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-paddypower-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["paddypower"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },

  ".provider-188bet-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["188bet"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-sbobet-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["sbobet"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-unibet-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["unibet"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-sportingbet-inverse": {
    textShadow: "0px 0px 2px #fff",
    backgroundColor: customColors["sportingbet"],
    color: "#fff",
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
    marginBottom: "2px !important",
  },
  ".provider-inverse": {
    minWidth: "86px",
    width: "min-content",
    textAlign: "center",
  },

  ".uni-competition": {},
  ".page-scrolling-holder": {
    maxHeight: "calc(100vh - 320px)",
    overflowY: "scroll",
    scrollbarWidth: "none",
  },
  ".highlight": {
    backgroundColor: "#dfdfdf",
    transition: "background-color 1s linear",
  },
  ".float-button": {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    height: "50px",
    width: "50px",
    borderRadius: "30px",
    backgroundColor: "#cb0c9f !important",
    boxShadow:
      "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
  },
  ".float-button-icon": {
    fontSize: "3rem !important",
    marginTop: "-5px",
    transform: "rotate(-90deg)",
    marginLeft: "-12px",
    color: "#fff",
  },
  ".float-button > button > .float-button-icon": {
    fontSize: "3rem !important",
  },
  ".fixed-table-header": {
    position: "absolute",
    zIndex: "1000",
    height: "72px",
    width: "inherit",
    backgroundColor: "#fff",
  },
  ".fixed-table-body": {
    position: "relative",
    display: "block !important",
    scrollbarWidth: "none",
    top: "60px",
  },

  "#fixtures-top > tr": {
    verticalAlign: "top !important",
    height: "100%",
    display: "block",
  },
  "#fixtures-top > tr > td": {
    maxHeight: "fit-content",
    height: "100%",
    display: "block",
  },

  "#fixtures-table-holder": {
    height: "calc(100vh - 320px)",
    scrollbarWidth: "none",
  },
  ".table-fixed-footer": {
    marginTop: "1em",
    marginBottom: "1em",
  },
  ".table-fixed-footer-left": { position: "absolute", left: "3em" },
  ".table-fixed-footer-right": { position: "absolute", right: "3em" },

  ".table-relative": {
    position: "relative",
  },

  ".table-relative > #zero-data": {
    top: "180px",
  },

  ".table-relative-footer": {
    paddingBottom: "10px !important",
  },

  ".table-relative-footer > .table-fixed-footer-right": {
    position: "relative",
    right: "0px",
  },

  "#signal-type": {
    zIndex: 20000,
  },

  "#sport-filter": {
    zIndex: 20000,
  },

  ".table-fixed-tools": {
    marginTop: "1em",
    marginBottom: "1em",
    zIndex: "2",
    position: "relative",
  },
  ".table-fixed-tools-left": { position: "absolute", left: "3em" },
  ".table-fixed-tools-right": { position: "absolute", right: "3em", display: "flex" },
  "ul.no-bullets": {
    listStyleType: "none" /* Remove bullets */,
    padding: "0" /* Remove padding */,
    margin: "0" /* Remove margins */,
  },
  ".won-color": {
    color: "lightGreen",
  },
  ".lost-color": {
    color: "#e81717",
  },
  ".refund-color": {
    color: "#17c1e8",
  },
  ".half_lost-color": {
    color: "orange",
  },
  ".half_won-color": {
    color: "#d5ee90",
  },
  ".unsettled-color": {
    color: "#b5a7a7",
  },
  ".MuiSvgIcon-root.MuiSvgIcon-fontSizeInherit.MuiStepIcon-root.Mui-active": {
    fill: "#cb0c9f !important",
    stroke: "#cb0c9f !important",
    boxShadow: "0rem 0rem 0rem 0.125rem #cb0c9f",
    borderColor: "#fff",
    background: "#cb0c9f",
  },
  "#sport-filter-export": {
    minWidth: "240px",
  },

  "#sport-filter-export > div > div": {
    flexWrap: "wrap",
  },
  "#sport-filter-export > div > div:first-of-type": {
    padding: "10px 8px",
  },
  "#sport-filter-export > div > div > div": {
    margin: "1px",
  },
  "#sport-filter-export > div ": {
    // display: "flex",
    // flexWrap: "wrap",
    // "-moz-box-pack": "justify",
    // justifyContent: "space-between",
    // minHeight: "38px",
    // outline: "0px !important",
    // position: "relative",
    // boxSizing: "border-box",
    height: "fit-content",
  },
  ".multiselectwrap > div > div": {
    flexWrap: "wrap",
  },
  ".multiselectwrap > div ": {
    height: "auto",
    paddingBottom: "5px",
    paddingTop: "5px",
  },
  ".multiselectwrap > div > div > div": {
    marginTop: "2px",
    marginBottom: "2px",
  },
  ".modal > .table-fixed-footer": {
    position: "relative",
  },
  ".matched": {
    color: "rgb(203, 12, 159) !important",
  },

  ".unmatched": {
    color: "#637eb3 !important",
  },

  ".cell-width": {
    maxWidth: "140px",
    overflowWrap: "break-word",
  },
  ".cell-double-width": {
    maxWidth: "240px",
    overflowWrap: "break-word",
  },
  ".in_progress": {
    color: "green !important",
  },
  ".not_started_yet": {
    color: "#ff6c00 !important",
  },
  ".finished": {
    color: "red !important",
  },
  ".coverage_lost": {
    color: "orange !important",
  },
  ".prefinished": {
    color: "#ff6c00 !important",
  },
  ".suspended": {
    color: "red !important",
  },
  ".betfoot-button": {
    color: "#002f5f !important",
  },
  ".vbet-button": {
    color: "#a71f67 !important",
  },
  ".efbet-button": {
    color: "rgb(235, 195, 23) !important",
  },
  ".sofa-button": {
    color: "rgb(42, 58, 172) !important",
  },
  ".live-table-refresh": {
    position: "absolute",
    top: "90px",
    right: "10px",
    width: "40px",
    height: "40px",
    zIndex: "11",
  },
  ".live-table-refresh button": {
    margin: " 0px",
    padding: "0px",
    width: "32px !important",
    maxWidth: "32px",
    minWidth: "32px",
    height: "36px",
  },
  ".live-table-refresh button .material-icons-round": {
    fontSize: "1.3rem !important",
  },
  ".unsort": {
    backgroundColor: "#f8f9fa !important",
    borderRadius: "4px !important",
    border: "1px solid #cecece !important",
    margin: "0px 15px !important",
    color: "#ff005490 !important",
  },
  ".sort": {
    backgroundColor: "#f8f9fa !important",
    borderRadius: "4px !important",
    border: "1px solid #cecece !important",
    margin: "0px 15px !important",
  },
  ".pre-bet": {
    color: "green",
  },
  ".live-bet": {
    color: "orange",
  },
  ".sp-value": {
    maxWidth: "60px",
  },

  "#loader": {
    // backgroundColor: "rgba(206, 206, 206, 0.3)",
    position: "absolute",
    height: "100%",
    width: "100%",
    zIndex: "100",
    top: "230px",
  },
  "#loader > .MuiBackdrop-root": {
    position: "absolute",
    backgroundColor: "rgba(0, 0, 0, 0.1) !important",
    color: "#58c9ee !important",
    alignItems: "start !important",
    paddingTop: "50px",
  },

  "#filter-loader": {
    // backgroundColor: "rgba(206, 206, 206, 0.3)",
    position: "absolute",
    height: "100%",
    width: "100%",
    zIndex: "100",
    top: "260px",
  },
  "#filter-loader > .MuiBackdrop-root": {
    position: "absolute",
    backgroundColor: "rgba(0, 0, 0, 0.1) !important",
    color: "#58c9ee !important",
    alignItems: "start !important",
    paddingTop: "50px",
  },

  "#fixtures-loader": {
    // backgroundColor: "rgba(206, 206, 206, 0.3)",
    position: "absolute",
    height: "100%",
    width: "100%",
    zIndex: "100",
    top: "200px",
  },
  "#fixtures-loader > .MuiBackdrop-root": {
    position: "absolute",
    backgroundColor: "rgba(0, 0, 0, 0.1) !important",
    color: "#58c9ee !important",
    alignItems: "start !important",
    paddingTop: "50px",
  },

  "#markets-loader": {
    // backgroundColor: "rgba(206, 206, 206, 0.3)",
    position: "absolute",
    height: "100%",
    width: "100%",
    zIndex: "100",
    top: "0px",
  },
  "#markets-loader > .MuiBackdrop-root": {
    position: "absolute",
    backgroundColor: "rgba(0, 0, 0, 0.1) !important",
    color: "#58c9ee !important",
    alignItems: "start !important",
    paddingTop: "50px",
  },

  ".monitoring-pregame-tab": {
    color: "rgb(52, 71, 103)",
    fontSize: "0.875rem !important",
    opacity: 1,
    transition:
      "opacity 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    padding: "2px 2px 2px 5px",
  },
  ".pregame-button > .monitoring-pregame-tab:hover": {
    color: "rgb(203, 12, 159)",
    opacity: "1 !important",
  },
  ".pregame-button:hover > .monitoring-pregame-tab": {
    color: "rgb(203, 12, 159)",
    opacity: "1 !important",
  },
  ".monitoring-inplay-tab": {
    color: "rgb(52, 71, 103)",
    fontSize: "0.875rem !important",
    opacity: 1,
    transition:
      "opacity 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    padding: "2px 2px 2px 5px",
  },
  ".inplay-button .monitoring-inplay-tab:hover": {
    color: "rgb(203, 12, 159)",
    opacity: "1 !important",
  },
  ".inplay-button:hover > .monitoring-inplay-tab": {
    color: "rgb(203, 12, 159)",
    opacity: "1 !important",
  },
  ".selected-sport": {
    backgroundColor: "rgb(244, 244, 244) !important",
    color: "#17c1e8 !important",
    fontFamily: "Roboto",
    padding: "0.5rem !important",
  },
  ".selected-sport > div": {
    color: "#17c1e8 !important",
    fontSize: "0.875rem",
    fontWeight: "500",
  },
  ".regular-sport": {
    color: "rgba(58, 65, 111, 0.7) !important",
    fontFamily: "Roboto",
    padding: "0.5rem !important",
  },
  ".regular-sport > div": {
    color: "rgba(58, 65, 111, 0.7) !important",
    fontSize: "0.875rem",
  },
  ".regular-sport > .sport-counter-num": {
    borderRadius: "20px",
    width: "fit-content",
    fontSize: "0.65rem !important",
    marginLeft: "10px",
    textAlign: "center",
    backgroundColor: "rgb(82, 95, 127, 0.4)",
    color: "rgb(255, 255, 255) !important",
    fontWeight: "400",
    paddingRight: "5px",
    paddingLeft: "5px",
    boxShadow: "rgb(157, 157, 157) 0px 0px 5px",
    opacity: "0.4 !important",
  },
  ".regular-sport > .hasEvents.sport-counter-num": {
    backgroundColor: "rgba(203, 12, 159, 0.4)",
  },
  ".regular-sport > .hasEvents.sport-counter-num:hover": {
    backgroundColor: "rgba(203, 12, 159, 1)",
  },
  ".regular-sport:hover > .hasEvents.sport-counter-num": {
    backgroundColor: "rgba(203, 12, 159, 1)",
  },
  ".selected-sport > .hasEvents.sport-counter-num": {
    border: "1px solid rgb(125, 0, 97)",
    borderRadius: "20px",
    width: "fit-content",
    fontSize: "10px",
    marginLeft: "10px",
    textAlign: "center",
    backgroundColor: "rgb(203, 12, 159)",
    color: "rgb(255, 255, 255) !important",
    fontWeight: "600",
    paddingRight: "5px",
    paddingLeft: "5px",
    boxShadow: "rgb(151, 151, 151) 0px 0px 5px",
  },
  ".selected-sport > .sport-counter-num": {
    border: "1px solid rgb(125, 0, 97)",
    borderRadius: "20px",
    width: "fit-content",
    fontSize: "10px",
    marginLeft: "10px",
    textAlign: "center",
    backgroundColor: "rgb(82, 95, 127)",
    color: "rgb(255, 255, 255) !important",
    fontWeight: "600",
    paddingRight: "5px",
    paddingLeft: "5px",
    boxShadow: "rgb(151, 151, 151) 0px 0px 5px",
  },
  ".sport-counter-inplay-num": {
    border: "1px solid rgb(125, 0, 97)",
    borderRadius: "20px",
    width: "fit-content",
    fontSize: "10px",
    textAlign: "center",
    backgroundColor: "rgb(82, 95, 127)",
    color: "rgb(255, 255, 255) !important",
    fontWeight: "600",
    paddingRight: "5px",
    paddingLeft: "5px",
    boxShadow: "rgb(151, 151, 151) 0px 0px 5px",
    height: "fit-content",
    marginLeft: "auto",
    marginTop: "0.3rem",
    marginRight: "1rem",
    opacity: 0.4,
  },
  ".sport-counter-inplay-num.inplay-events": {
    border: "1px solid rgb(125, 0, 97)",
    borderRadius: "20px",
    width: "fit-content",
    fontSize: "10px",
    textAlign: "center",
    backgroundColor: "rgb(203, 12, 159)",
    color: "rgb(255, 255, 255) !important",
    fontWeight: "600",
    paddingRight: "5px",
    paddingLeft: "5px",
    boxShadow: "rgb(151, 151, 151) 0px 0px 5px",
    height: "fit-content",
    marginLeft: "auto",
    marginTop: "0.3rem",
    marginRight: "1rem",
    opacity: 1,
  },
  ".sport-counter-pregame-num": {
    border: "1px solid rgb(125, 0, 97)",
    borderRadius: "20px",
    width: "fit-content",
    fontSize: "10px",
    textAlign: "center",
    backgroundColor: "rgb(82, 95, 127)",
    color: "rgb(255, 255, 255) !important",
    fontWeight: "600",
    paddingRight: "5px",
    paddingLeft: "5px",
    boxShadow: "rgb(151, 151, 151) 0px 0px 5px",
    height: "fit-content",
    marginLeft: "auto",
    marginTop: "0.3rem",
    marginRight: "1rem",
    opacity: 0.4,
  },
  ".sport-counter-pregame-num.pregame-events": {
    border: "1px solid rgb(125, 0, 97)",
    borderRadius: "20px",
    width: "fit-content",
    fontSize: "10px",
    textAlign: "center",
    backgroundColor: "rgb(203, 12, 159)",
    color: "rgb(255, 255, 255) !important",
    fontWeight: "600",
    paddingRight: "5px",
    paddingLeft: "5px",
    boxShadow: "rgb(151, 151, 151) 0px 0px 5px",
    height: "fit-content",
    marginLeft: "auto",
    marginTop: "0.3rem",
    marginRight: "1rem",
    opacity: 1,
  },
  ".pregame-button:hover": {
    backgroundColor: "rgba(0, 159, 255, 0.2) !important",
    backgroundColor: "rgb(244, 244, 244) !important",
    opacity: 1,
  },
  ".inplay-button:hover": {
    backgroundColor: "rgba(0, 255, 28, 0.2) !important",
    backgroundColor: "rgb(244, 244, 244) !important",
    color: "rgb(203, 12, 159)",
    opacity: 1,
  },
  ".pregame-button:hover > .sport-counter-pregame-num": {
    backgroundColor: "rgb(203, 12, 159) !important",
    opacity: 1,
  },
  ".inplay-button:hover > .sport-counter-inplay-num": {
    backgroundColor: "rgb(203, 12, 159) !important",
    opacity: 1,
  },
  ".sport-logo": {
    width: "15px",
    filter: "drop-shadow(0px 0px 1px #282828)",
  },
  ".waterpolo-logo": {
    content: `url(${water_polo})`,
  },
  ".handball-logo": {
    content: `url(${handball})`,
  },
  ".soccer-logo": {
    content: `url(${soccer})`,
    backgroundColor: "#0006",
    borderRadius: "10px",
  },
  ".volleyball-logo": {
    content: `url(${volleyball})`,
  },
  ".beachvolleyball-logo": {
    content: `url(${volleyball})`,
  },
  ".basketball-logo": {
    content: `url(${basketball})`,
  },
  ".futsal-logo": {
    content: `url(${futsal})`,
  },
  ".badminton-logo": {
    content: `url(${badminton})`,
  },
  ".americanfootball-logo": {
    content: `url(${american_football})`,
  },
  ".cricket-logo": {
    content: `url(${cricket})`,
  },
  ".baseball-logo": {
    content: `url(${baseball})`,
  },
  ".darts-logo": {
    content: `url(${darts})`,
  },
  ".golf-logo": {
    content: `url(${golf})`,
  },
  ".bowls-logo": {
    content: `url(${bowls})`,
  },
  ".greyhounds-logo": {
    content: `url(${greyhounds})`,
  },
  ".horseracing-logo": {
    content: `url(${horse_racing})`,
  },
  ".icehockey-logo": {
    content: `url(${ice_hockey})`,
  },
  ".hockey-logo": {
    content: `url(${hockey})`,
  },
  ".fieldhockey-logo": {
    content: `url(${field_hockey})`,
  },
  ".bandy-logo": {
    content: `url(${field_hockey})`,
  },
  ".squash-logo": {
    content: `url(${squash})`,
  },
  ".pistolshooting-logo": {
    content: `url(${pistol_shooting})`,
  },
  ".shooting-logo": {
    content: `url(${pistol_shooting})`,
  },
  ".tennis-logo": {
    content: `url(${tennis})`,
  },
  ".mma-logo": {
    content: `url(${mma})`,
  },
  ".tabletennis-logo": {
    content: `url(${table_tennis})`,
  },
  ".lacrosse-logo": {
    content: `url(${lacrosse})`,
  },
  ".snooker-logo": {
    content: `url(${snooker})`,
  },
  ".rugbyleague-logo": {
    content: `url(${rugby_league})`,
  },
  ".rugbyunion-logo": {
    content: `url(${rugby_union})`,
  },
  ".boxing-logo": {
    content: `url(${boxing})`,
  },
  ".cycling-logo": {
    content: `url(${cycling})`,
  },
  ".floorball-logo": {
    content: `url(${floorball})`,
  },
  ".aussierules-logo": {
    content: `url(${aussie_rules})`,
  },
  ".netball-logo": {
    content: `url(${netball})`,
  },
  ".chess-logo": {
    content: `url(${netball})`,
  },
  ".sailing-logo": {
    content: `url(${sailing})`,
  },
  ".formula1-logo": {
    content: `url(${formula1})`,
  },
  ".curling-logo": {
    content: `url(${curling})`,
  },
  ".archery-logo": {
    content: `url(${archery})`,
  },
  ".archeryshooting-logo": {
    content: `url(${archery})`,
  },
  ".trotting-logo": {
    content: `url(${trotting})`,
  },
  ".politics-logo": {
    content: `url(${politics})`,
  },
  ".valorant-logo": {
    content: `url(${esports})`,
  },
  ".leagueoflegends-logo": {
    content: `url(${esports})`,
  },
  ".dota2-logo": {
    content: `url(${esports})`,
  },
  ".counterstrike-logo": {
    content: `url(${esports})`,
  },
  ".kingofglory-logo": {
    content: `url(${esports})`,
  },
  ".gaelichurling-logo": {
    content: `url(${gaelic})`,
  },
  ".gaelicfootball-logo": {
    content: `url(${gaelicfootball})`,
  },
  ".beachsoccer-logo": {
    content: `url(${soccer})`,
  },
  ".overwatch2-logo": {
    content: `url(${esports})`,
  },
  ".starcraft-logo": {
    content: `url(${esports})`,
  },
  ".starcraft2-logo": {
    content: `url(${esports})`,
  },
  ".warcraft-logo": {
    content: `url(${esports})`,
  },
  ".warcraft3-logo": {
    content: `url(${esports})`,
  },
  ".mobilelegends-logo": {
    content: `url(${esports})`,
  },
  ".apexlegends-logo": {
    content: `url(${esports})`,
  },
  ".rainbowsix-logo": {
    content: `url(${esports})`,
  },
  ".crossfire-logo": {
    content: `url(${esports})`,
  },
  ".rocketleague-logo": {
    content: `url(${esports})`,
  },
  ".arenaofvalor-logo": {
    content: `url(${esports})`,
  },
  ".halo-logo": {
    content: `url(${esports})`,
  },
  ".callofduty-logo": {
    content: `url(${esports})`,
  },
  ".pubg-logo": {
    content: `url(${esports})`,
  },
  ".worldofwarcraft-logo": {
    content: `url(${esports})`,
  },
  ".ageofempires-logo": {
    content: `url(${esports})`,
  },
  ".cross-countryskiing-logo": {
    content: `url(${crosscountryskiing})`,
  },
  ".alpineskiing-logo": {
    content: `url(${alpineskiing})`,
  },
  ".nordicski-logo": {
    content: `url(${nordicski})`,
  },
  ".skijumping-logo": {
    content: `url(${skijumping})`,
  },
  ".freestyleskiing-logo": {
    content: `url(${freestyleskiing})`,
  },
  ".biathlon-logo": {
    content: `url(${biathlon})`,
  },
  ".surfing-logo": {
    content: `url(${surfing})`,
  },
  ".speedway-logo": {
    content: `url(${speedway})`,
  },
  ".motorbike-logo": {
    content: `url(${motorbike})`,
  },
  ".motorsport-logo": {
    content: `url(${motorsport})`,
  },
  ".wintersports-logo": {
    content: `url(${wintersports})`,
  },
  ".weightlifting-logo": {
    content: `url(${weightlifting})`,
  },
  ".wrestling-logo": {
    content: `url(${wrestling})`,
  },
  ".skeleton-logo": {
    content: `url(${skeleton})`,
  },
  ".bowling-logo": {
    content: `url(${bowling})`,
  },
  ".figureskating-logo": {
    content: `url(${figureskating})`,
  },
  ".speedskating-logo": {
    content: `url(${speedskating})`,
  },
  ".snowboarding-logo": {
    content: `url(${snowboarding})`,
  },
  ".shorttrackspeedskating-logo": {
    content: `url(${shorttrackspeedskating})`,
  },
  ".poker-logo": {
    content: `url(${poker})`,
  },
  ".canoeing-logo": {
    content: `url(${canoeing})`,
  },
  ".diving-logo": {
    content: `url(${diving})`,
  },
  ".gymnastics-logo": {
    content: `url(${gymnastics})`,
  },
  ".softball-logo": {
    content: `url(${softball})`,
  },
  ".pesapallo-logo": {
    content: `url(${softball})`,
  },
  ".skateboarding-logo": {
    content: `url(${skateboarding})`,
  },
  ".petanque-logo": {
    content: `url(${petanque})`,
  },
  ".financials-logo": {
    content: `url(${financials})`,
  },
  ".showjumping-logo": {
    content: `url(${showjumping})`,
  },
  ".swimming-logo": {
    content: `url(${swimming})`,
  },
  ".padel-logo": {
    content: `url(${padel})`,
  },
  ".entertainment-logo": {
    content: `url(${entertainment})`,
  },
  ".bobsleigh-logo": {
    content: `url(${bobsleigh})`,
  },
  ".luge-logo": {
    content: `url(${luge})`,
  },
  ".nordiccombined-logo": {
    content: `url(${nordiccombined})`,
  },
  ".sepaktakraw-logo": {
    content: `url(${sepaktakraw})`,
  },
  ".equestrian-logo": {
    content: `url(${showjumping})`,
  },
  ".rugbysevens-logo": {
    content: `url(${rugby_union})`,
  },
  ".pool-logo": {
    content: `url(${pool})`,
  },
  ".basquepelota-logo": {
    content: `url(${pelota})`,
  },

  ".swal2-select": {
    borderRadius: "10px !important",
    border: "1px solid #cecece !important",
    padddingRight: "10px !important",
  },
  ".password-eye-icon": {
    color: "#163552 !important",
    cursor: "pointer !important",
    opacity: "0.5",
    fontWeight: "400 !important",
  },
  ".password-eye-icon:hover": {
    cursor: "pointer !important",
    opacity: "0.7",
    fontWeight: "400 !important",
  },
  "#zero-data": {
    background: `no-repeat 50% url(${nodata})`,
    backgroundSize: "contain",
    position: "absolute",
    height: "100px",
    width: "100%",
    zIndex: "100",
    top: "230px",
    textAlign: "center",
    color: "#ddd",
  },
  "#zero-data::after": {
    content: '"No Data"',
    display: "block",
    textAlign: "center",
    verticalAlign: "unset",
    position: "absolute",
    bottom: "-30px",
    width: "inherit",
  },

  ".region-fixtures-table-holder": {
    position: "relative",
  },

  ".region-fixtures-table-holder #zero-data": {
    top: "150px",
  },

  ".conflicts-holder": {
    position: "relative",
  },

  ".conflicts-holder #zero-data": {
    top: "130px",
  },

  ".workflow_undefined": {
    backgroundColor: "#cecece30 !important",
    color: "#cecece !important",
    padding: "0.275rem 0.75rem !important",
    lineHeight: "1.4 !important",
    fontSize: "0.75rem !important",
    cursor: "normal",
  },

  ".workflow_enabled": {
    backgroundColor: "#7af27a42 !important",
    color: "green !important",
    padding: "0.275rem 0.75rem !important",
    lineHeight: "1.4 !important",
    fontSize: "0.75rem !important",
  },
  ".workflow_disabled": {
    backgroundColor: "#ff000030 !important",
    color: "red !important",
    padding: "0.275rem 0.75rem !important",
    lineHeight: "1.4 !important",
    fontSize: "0.75rem !important",
  },

  ".bubble": {
    border: "1px solid rgb(125, 0, 97)",
    borderRadius: "10px",
    width: "fit-content",
    fontSize: "10px",
    marginLeft: "10px",
    textAlign: "center",
    backgroundColor: "rgb(203, 12, 159)",
    fontWeight: "bold",
    paddingRight: "5px",
    paddingLeft: "5px",
    color: "#ffffff !important",
    boxShadow: "rgb(151, 151, 151) 0px 0px 5px",
  },
  "#suspension-provider-barrier > div > div > div": {
    minWidth: "revert",
  },
  ".providers-priority-holder": {
    display: "flex  !important",
    flexDirection: "column",
    flexWrap: "wrap",
    maxHeight: "140px",
  },
  ".provider-priority-label": {
    fontSize: "0.875rem !important",
    lineHeight: "1.5 !important",
    textTransform: "uppercase",
    letterSpacing: "0.02857em  !important",
    opacity: 1,
    textTransform: "capitalize",
    verticalAlign: "unset",
    textDecoration: "none",
    color: "#67748e !important",
    fontWeight: "500 !important",
  },

  ".signals-available-providers": {
    display: "flex !important",
    flexDirection: "column !important",
    flexWrap: "wrap",
    maxHeight: "260px",
  },

  ".signal-available-providers-item": {
    display: "flex !important",
    flexDirection: "row",
    flex: "1 1",
    // maxHeight: "28px",
  },

  ".select-diselect": {
    fontSize: ".65rem !important",
    paddingLeft: "5px !important",
    margin: "0px !important",
    height: "25px !important",
    lineHeight: "1 !important",
    paddingRight: "5px !important",
    paddingTop: "0px !important",
    paddingBottom: "0px !important",
    minHeight: "fit-content !important",
  },

  ".available-providers": {
    display: "flex !important",
    flexDirection: "column !important",
    flexWrap: "wrap",
    maxHeight: "140px",
  },

  ".available-providers-item": {
    display: "flex !important",
    flexDirection: "row",
    flex: "1 1",
    maxHeight: "28px",
  },
  ".white-html-tooltip > div": {
    backgroundColor: "#e9ecef !important",
    color: "#000 !important",
  },
  ".platform-providers-holder": {
    maxHeight: "550px",
  },

  ".linked-event": {
    background: "#fff0f0",
  },
  ".table-button": {
    maxWidth: "170px",
    textAlign: "left !important",
    display: "flex !important",
    padding: "0px !important",
    fontSize: "0.70rem !important",
  },
  ".select-all-checkbox > svg": {
    fill: "currentColor !important",
    fontSize: "1.2rem",
    borderColor: "currentColor",
    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"),linear-gradient(310deg, currentColor, currentColor)`,
    borderRadius: "5px",
  },
  ".select-all-checkbox-indeterminate > svg": {
    fill: "currentColor !important",
    backgroundColor: "#fff !important",
  },
  ".odd-setting-menu": {
    top: "0px",
    left: "10px",
    width: "max-content",
    maxWidth: "max-content",
    // background: "#fff",
  },
  ".odd-setting-menu-holder": {
    display: "flex",
    overflow: "visible",
    // maxWidth: "100px",
  },
  ".odd-setting-menu > div": {
    maxWidth: "150px",
    background: "#fff",
    width: "max-content",
  },
  ".odd-setting-menu > div:nth-of-type(1) > div:nth-of-type(1) > div:nth-of-type(1)": {
    maxWidth: "100px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    width: "100px",
    height: "10px",
    lineHeight: "10px",
    whiteSpace: "nowrap",
  },
  ".filter-odd-settings-info": {
    position: "absolute",
    top: "120px",
    right: "100px",
    width: "180px",
    height: "50px",
    textAlign: "right",
  },

  ".market-setting-menu": {
    top: "0px",
    left: "10px",
    width: "max-content",
    maxWidth: "max-content",
    // background: "#fff",
  },
  ".market-setting-menu-holder": {
    display: "flex",
    overflow: "visible",
    // maxWidth: "100px",
  },

  ".market-setting-menu > div": {
    maxWidth: "150px",
    background: "#fff",
    width: "max-content",
  },
  ".market-setting-menu > div:nth-of-type(1) > div:nth-of-type(1) > div:nth-of-type(1)": {
    maxWidth: "100px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    width: "100px",
    height: "10px",
    lineHeight: "10px",
    whiteSpace: "nowrap",
  },

  ".table-multiselected-action": {
    maxWidth: "750px",
    position: "absolute",
    top: "110px",
    right: "300px",
    width: "750px",
  },
  ".table-multiselected-action-market": {
    maxWidth: "850px",
    position: "absolute",
    top: "50px",
    right: "300px",
    width: "850px",
  },
  ".table-multiselected-action-market-settings": {
    maxWidth: "850px",
    position: "absolute",
    top: "20px",
    right: "200px",
    width: "850px",
  },
  ".table-multiselected-action-template": {
    // maxWidth: "750px",
    // position: "absolute",
    // top: "135px",
    // right: "360px",
    // width: "750px",
    maxWidth: "920px",
    position: "absolute",
    top: "135px",
    right: "280px",
    width: "920px",
  },
  ".table-multiselected-action-filter": {
    maxWidth: "920px",
    position: "absolute",
    top: "105px",
    right: "280px",
    width: "920px",
  },
  ".table-competition-multiselected-action-filter": {
    maxWidth: "920px",
    position: "absolute",
    top: "180px",
    right: "200px",
    width: "920px",
  },
  ".documentation-card": {
    maxHeight: "fit-content !important",
  },
  "#fixture-body": {
    position: "relative",
    height: "100%",
    // backgroundColor: "aliceblue",
    overflow: "hidden",
  },
  "#market-groups-holder": {
    // height: "40px",
    // backgroundColor: "antiquewhite",
    position: "sticky",
    zIndex: 100000000000000,
  },
  "#markets-holder": {
    overflowY: "auto",
    height: "calc(100vh - 290px)",
    width: "100%",
    // backgroundColor: "beige",
    scrollbarWidth: "thin",
    flexDirection: "column",
    display: "block",
    paddingRight: "10px",
  },
  ".market-box": {
    borderRadius: "10px",
    overflow: "hidden",
    backgroundColor: "#dfe6ec",
    margin: "5px",
    border: "1px solid #c8ced21a",
    borderCollapse: "reset",
  },
  ".odds-column-grid-holder": {
    padding: "0px !important",
  },
  ".odds-grid-holder": {
    display: "flex",
    margin: "5px",
  },
  ".grid-container": {
    display: "flex !important",
    flexDirection: "column !important",
    margin: "5px !important",
    // backgroundColor: "aliceblue",
    width: "100% !important",
  },
  ".grid-item": {
    backgroundColor: "rgba(255, 255, 255, 0.45)",
    padding: "5px 10px",
    textAlign: "left",
    width: "100%",
    border: "1px solid #12324f1c",
    borderRadius: "10px",
    // maxHeight: "50px",
    fontWeight: "400",
    marginBottom: "4px",
    marginTop: "4px",
  },
  ".grid-item-ml": {
    backgroundColor: "#6fd6ed2e",
    padding: "5px 10px",
    textAlign: "left",
    width: "100%",
    border: "1px solid #6fd6ed6e",
    borderRadius: "10px",
    // maxHeight: "50px",
    fontWeight: "400",
    marginBottom: "4px",
    marginTop: "4px",
  },
  ".filtered-grid-item": {
    backgroundColor: "#ff000020",
    padding: "5px 10px",
    textAlign: "left",
    width: "100%",
    border: "1px solid #12324f1c",
    borderRadius: "10px",
    // maxHeight: "50px",
    fontWeight: "400",
    marginBottom: "4px",
    marginTop: "4px",
  },
  ".filtered-grid-item-ml": {
    backgroundColor: "#ff000020",
    padding: "5px 10px",
    textAlign: "left",
    width: "100%",
    border: "1px solid #6fd6ed6e",
    borderRadius: "10px",
    // maxHeight: "50px",
    fontWeight: "400",
    marginBottom: "4px",
    marginTop: "4px",
  },
  ".odd-value": {
    textAlign: "right !important",
    color: "rgb(203, 12, 159) !important",
    fontSize: "0.875rem !important",
    fontWeight: "400",
  },

  ".odd-value-trader": {
    padding: "5px !important",
  },

  ".odd-label": {
    textAlign: "left",
    fontSize: "0.875rem !important",
    fontWeight: "400",
  },

  ".odd-trader": {
    padding: "5px !important",
  },

  ".odd-value-bet": {
    textAlign: "right !important",
    color: "rgb(203, 12, 159) !important",
    fontSize: "0.875rem !important",
    fontWeight: "400",
    cursor: "pointer",
  },
  ".market-open": {
    backgroundColor: "rgb(240, 243, 246)",
    cursor: "pointer",
  },
  ".market-open:hover": {
    backgroundColor: "rgb(242, 246, 249)",
    cursor: "pointer",
  },
  ".market-closed": {
    backgroundColor: "#ffffff20",
    cursor: "pointer",
  },
  ".market-closed:hover": {
    cursor: "pointer",
    backgroundColor: "#ffffff50",
  },
  ".market-filtered-open": {
    backgroundColor: "#ff000020",
    cursor: "pointer",
  },
  ".market-filtered-open:hover": {
    backgroundColor: "#ff000050",
    cursor: "pointer",
  },
  ".market-filtered-closed": {
    backgroundColor: "#ff000020",
    cursor: "pointer",
  },
  ".market-filtered-closed:hover": {
    cursor: "pointer",
    backgroundColor: "#ff000050",
  },

  ".fixture-header": {
    width: "100%",
    marginBottom: "10px",
    backgroundColor: "#14325021 !important",
  },
  ".fixture-header-1": {
    width: "100%",
    backgroundImage: `url(${fixture_header_1})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-2": {
    width: "100%",
    backgroundImage: `url(${fixture_header_2})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-3": {
    width: "100%",
    backgroundImage: `url(${fixture_header_3})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-4": {
    width: "100%",
    backgroundImage: `url(${fixture_header_4})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-5": {
    width: "100%",
    backgroundImage: `url(${fixture_header_5})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-6": {
    width: "100%",
    backgroundImage: `url(${fixture_header_6})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-7": {
    width: "100%",
    backgroundImage: `url(${fixture_header_7})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-8": {
    width: "100%",
    backgroundImage: `url(${fixture_header_8})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-9": {
    width: "100%",
    backgroundImage: `url(${fixture_header_9})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-10": {
    width: "100%",
    backgroundImage: `url(${fixture_header_10})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },

  ".fixture-header-11": {
    width: "100%",
    backgroundImage: `url(${fixture_header_11})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-12": {
    width: "100%",
    backgroundImage: `url(${fixture_header_12})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-13": {
    width: "100%",
    backgroundImage: `url(${fixture_header_13})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-14": {
    width: "100%",
    backgroundImage: `url(${fixture_header_14})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-15": {
    width: "100%",
    backgroundImage: `url(${fixture_header_15})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-16": {
    width: "100%",
    backgroundImage: `url(${fixture_header_16})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-17": {
    width: "100%",
    backgroundImage: `url(${fixture_header_17})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-18": {
    width: "100%",
    backgroundImage: `url(${fixture_header_18})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-19": {
    width: "100%",
    backgroundImage: `url(${fixture_header_19})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-20": {
    width: "100%",
    backgroundImage: `url(${fixture_header_20})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-21": {
    width: "100%",
    backgroundImage: `url(${fixture_header_21})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-22": {
    width: "100%",
    backgroundImage: `url(${fixture_header_22})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-23": {
    width: "100%",
    backgroundImage: `url(${fixture_header_23})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-24": {
    width: "100%",
    backgroundImage: `url(${fixture_header_24})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-25": {
    width: "100%",
    backgroundImage: `url(${fixture_header_25})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-26": {
    width: "100%",
    backgroundImage: `url(${fixture_header_26})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-27": {
    width: "100%",
    backgroundImage: `url(${fixture_header_27})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-28": {
    width: "100%",
    backgroundImage: `url(${fixture_header_28})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-29": {
    width: "100%",
    backgroundImage: `url(${fixture_header_29})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-30": {
    width: "100%",
    backgroundImage: `url(${fixture_header_30})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-31": {
    width: "100%",
    backgroundImage: `url(${fixture_header_31})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-32": {
    width: "100%",
    backgroundImage: `url(${fixture_header_32})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-33": {
    width: "100%",
    backgroundImage: `url(${fixture_header_33})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-34": {
    width: "100%",
    backgroundImage: `url(${fixture_header_34})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-35": {
    width: "100%",
    backgroundImage: `url(${fixture_header_35})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-36": {
    width: "100%",
    backgroundImage: `url(${fixture_header_36})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-37": {
    width: "100%",
    backgroundImage: `url(${fixture_header_37})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-38": {
    width: "100%",
    backgroundImage: `url(${fixture_header_38})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-41": {
    width: "100%",
    backgroundImage: `url(${fixture_header_41})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-44": {
    width: "100%",
    backgroundImage: `url(${fixture_header_44})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-45": {
    width: "100%",
    backgroundImage: `url(${fixture_header_45})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-47": {
    width: "100%",
    backgroundImage: `url(${fixture_header_47})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-50": {
    width: "100%",
    backgroundImage: `url(${fixture_header_50})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-53": {
    width: "100%",
    backgroundImage: `url(${fixture_header_53})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-54": {
    width: "100%",
    backgroundImage: `url(${fixture_header_54})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-55": {
    width: "100%",
    backgroundImage: `url(${fixture_header_55})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-56": {
    width: "100%",
    backgroundImage: `url(${fixture_header_56})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-57": {
    width: "100%",
    backgroundImage: `url(${fixture_header_57})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-58": {
    width: "100%",
    backgroundImage: `url(${fixture_header_58})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-59": {
    width: "100%",
    backgroundImage: `url(${fixture_header_59})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-60": {
    width: "100%",
    backgroundImage: `url(${fixture_header_60})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },
  ".fixture-header-63": {
    width: "100%",
    backgroundImage: `url(${fixture_header_63})`,
    marginBottom: "10px",
    position: "absolute",
    height: "auto",
    display: "block",
    height: "210px",
    backgroundSize: "cover",
    opacity: "0.2",
  },

  ".fixture-oponent": {
    margin: "auto !important",
    minWidth: "40%",
    textAlign: "center",
  },

  ".region-competion-breadcramp": {
    padding: "5px 10px 5px 5px",
    backgroundColor: "#1332504d",
    fontSize: "0.85rem",
    color: "#fff",
    fontWeight: "500",
  },
  ".fixture-overview-footer": {
    textAlign: "right",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    backgroundColor: "#1836545e",
    color: "#1635524f",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  ".fixture-data": {
    position: "relative",
  },
  ".blured": {
    filter: "blur(4px)",
  },
  ".timeline-event-0": {
    textAlign: "center",
    fontSize: "0.75rem !important",
  },
  ".timeline-event-1": {
    textAlign: "left",
    fontSize: "0.75rem !important",
  },
  ".timeline-event-2": {
    textAlign: "right",
    fontSize: "0.75rem !important",
  },
  ".scoreboard-type": {
    width: "100%",
    textAlign: "center !important",
    fontSize: "0.85rem !important",
    fontWeight: 600,
  },
  ".scoreboard-value": {
    textAlign: "center !important",
    fontSize: "0.85rem !important",
  },
  ".live-stats-bars > span": {
    transform: "translate(0, 0) !important",
  },
  ".switch-unmuted": {
    color: "#cecece !important",
  },
  ".switch-muted": {
    color: "rgb(203, 12, 159) !important",
  },
  ".not-settled": {
    maxWidth: "140px !important",
  },
  ".already-settled": {
    backgroundColor: "#ff00000a",
    borderRadius: "10px",
    color: "#fff !important",
    border: "1px solid red",
    maxWidth: "140px !important",
  },
  ".time-exceeded": {
    background: "#fff0f0",
  },

  ".timeline-item-middle": {
    maxWidth: "280px",
    whiteSpace: "wrap !important",
  },
  ".timeline-item-left": {
    borderLeft: "3px solid #cecece !important",
    maxWidth: "280px",
    whiteSpace: "wrap !important",
  },
  ".timeline-item-right": {
    borderRight: "3px solid #cecece !important",
    maxWidth: "280px",
    whiteSpace: "wrap !important",
  },
  ".timeline-holder ul": {
    minWidth: "280px",
  },
  ".sport-breadcrumb": {
    color: "rgb(203, 12, 159)",
    fontWeight: "bold",
  },
  ".risk-rule-1": {
    color: "red",
  },
  ".risk-rule-2": {
    color: "red",
  },
  ".risk-rule-3": {
    color: "red",
  },
  ".risk-rule-4": {
    color: "#17c1e8",
  },
  ".hr-divider": {
    flexShrink: "0",
    borderWidth: "0px 0px medium",
    borderStyle: "solid solid none",
    borderColor: "rgba(0, 0, 0, 0.12) rgba(0, 0, 0, 0.12) currentcolor",
    backgroundColor: "transparent",
    backgroundImage:
      "linear-gradient(to right, rgba(52, 71, 103, 0), rgba(52, 71, 103, 0.9), rgba(52, 71, 103, 0)) !important",
    height: "0.0625rem",
    margin: "1rem 0px",
    opacity: "0.25",
  },
  ".modal-footer-buttons": {
    marginTop: "10px",
    marginBottom: "10px",
  },

  ".participant-logo": {
    width: "5rem",
    height: "5rem",
    filter: "drop-shadow(0px 0px 10px #000)",
  },

  ".default-participant-logo": {
    width: "5rem",
    height: "5rem",
    filter: "drop-shadow(0px 0px 10px #000)",
  },

  ".platform-provider-button": {
    width: "105px",
    position: "relative",
  },
};

export default globals;
